(() => {
  const ready = (callback) => document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', callback) : callback();

  /* V10.99 — filet de sécurité global : sans ça, une erreur JS n'importe où sur la page
     (galerie, carrousel, slider...) passe totalement inaperçue alors qu'elle peut empêcher
     le bouton d'achat de s'activer plus loin dans ce même fichier. On logue en console
     (visible dans les enregistrements Microsoft Clarity déjà installés) pour avoir enfin
     de la visibilité sur ces pannes silencieuses. */
  window.addEventListener('error', (event) => {
    try { console.error('[Pioupiou] Erreur JS non interceptée :', event.message, event.filename, event.lineno); } catch (_) {}
  });
  window.addEventListener('unhandledrejection', (event) => {
    try { console.error('[Pioupiou] Promesse rejetée non interceptée :', event.reason); } catch (_) {}
  });

  ready(() => {
    document.documentElement.classList.add('js-ready');
    const header = document.querySelector('[data-header]');
    const menuButton = document.querySelector('[data-menu-toggle]');
    const mobileMenu = document.querySelector('[data-mobile-menu]');
    const closeMenu = () => {
      if (!menuButton || !mobileMenu) return;
      menuButton.setAttribute('aria-expanded', 'false');
      mobileMenu.hidden = true;
      document.body.classList.remove('menu-open');
    };
    menuButton?.addEventListener('click', () => {
      const open = menuButton.getAttribute('aria-expanded') !== 'true';
      menuButton.setAttribute('aria-expanded', String(open));
      mobileMenu.hidden = !open;
      document.body.classList.toggle('menu-open', open);
    });
    mobileMenu?.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeMenu(); });

    const onScroll = () => header?.classList.toggle('is-scrolled', window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    const revealItems = document.querySelectorAll('[data-reveal]');
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }), { threshold: 0.1, rootMargin: '0px 0px -25px' });
      revealItems.forEach((item) => observer.observe(item));
    } else revealItems.forEach((item) => item.classList.add('is-visible'));

    /* V10.99 — isolation : tout ce bloc (galeries, carrousels, slider avant/après, avis)
       est purement visuel et ne touche jamais au panier. On l'enveloppe dans un try/catch
       pour qu'une erreur ici ne puisse plus jamais empêcher le code d'achat plus bas
       (data-product-section) de s'initialiser. */
    const galleryStates = new WeakMap();
    try {
    document.querySelectorAll('[data-comfort-gallery]').forEach((gallery) => {
      const mainImage = gallery.querySelector('[data-comfort-main-image]');
      const views = [...gallery.querySelectorAll('[data-comfort-view]')];
      const kicker = gallery.querySelector('[data-comfort-view-kicker]');
      const title = gallery.querySelector('[data-comfort-view-title]');
      const copy = gallery.querySelector('[data-comfort-view-copy]');
      if (!mainImage || !views.length) return;

      const activateView = (button) => {
        if (!button.dataset.src) return;
        mainImage.classList.add('is-switching');
        window.setTimeout(() => {
          if (button.dataset.srcset) mainImage.setAttribute('srcset', button.dataset.srcset);
          else mainImage.removeAttribute('srcset');
          if (button.dataset.sizes) mainImage.setAttribute('sizes', button.dataset.sizes);
          else mainImage.removeAttribute('sizes');
          mainImage.src = button.dataset.src;
          if (button.dataset.alt) mainImage.alt = button.dataset.alt;
          gallery.dataset.activeView = button.dataset.view || 'face';
          if (kicker) kicker.textContent = button.dataset.kicker || '';
          if (title) title.textContent = button.dataset.title || '';
          if (copy) copy.textContent = button.dataset.copy || '';
          mainImage.classList.remove('is-switching');
        }, 90);
        views.forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
      };

      views.forEach((button) => button.addEventListener('click', () => activateView(button)));
    });

    document.querySelectorAll('[data-media-marquee]').forEach((marquee) => {
      const track = marquee.querySelector('[data-media-track]');
      if (!track || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      [...track.children].forEach((item) => {
        const clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });
      marquee.classList.add('is-ready');
    });


    document.querySelectorAll('[data-bundle-trust-viewport]').forEach((viewport) => {
      const strip = viewport.closest('.bundle-trust-strip');
      const track = viewport.querySelector('.bundle-trust-strip__track');
      if (!track) return;

      let isPointerDown = false;
      let startX = 0;
      let startScrollLeft = 0;
      let resumeTimer = 0;
      let autoPaused = false;
      let lastTime = performance.now();
      /* V10.68 : mouvement assez visible pour ne plus donner l'impression
         que le bandeau est figé, sans gêner la lecture des cartes. */
      const speedPxPerSecond = 58;

      const halfWidth = () => track.scrollWidth / 2;
      const normalizeLoop = () => {
        const loop = halfWidth();
        if (!loop) return;
        if (viewport.scrollLeft >= loop) viewport.scrollLeft -= loop;
      };
      const pauseAuto = () => {
        autoPaused = true;
        window.clearTimeout(resumeTimer);
      };
      const resumeAutoSoon = () => {
        window.clearTimeout(resumeTimer);
        resumeTimer = window.setTimeout(() => {
          autoPaused = false;
          lastTime = performance.now();
        }, 1600);
      };

      const tick = (now) => {
        const dt = Math.min(50, now - lastTime);
        lastTime = now;
        if (!autoPaused && viewport.getClientRects().length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          viewport.scrollLeft += speedPxPerSecond * (dt / 1000);
          normalizeLoop();
        }
        requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);

      viewport.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        pauseAuto();
        const step = Math.max(220, Math.round(viewport.clientWidth * 0.72));
        viewport.scrollBy({ left: event.key === 'ArrowLeft' ? -step : step, behavior: 'smooth' });
        resumeAutoSoon();
      });

      viewport.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        isPointerDown = true;
        startX = event.clientX;
        startScrollLeft = viewport.scrollLeft;
        viewport.classList.add('is-dragging');
        pauseAuto();
        if (typeof viewport.setPointerCapture === 'function') {
          try { viewport.setPointerCapture(event.pointerId); } catch (error) {}
        }
      });

      viewport.addEventListener('pointermove', (event) => {
        if (!isPointerDown) return;
        viewport.scrollLeft = startScrollLeft - (event.clientX - startX);
        normalizeLoop();
      });

      const stopDragging = (event) => {
        if (!isPointerDown) return;
        isPointerDown = false;
        viewport.classList.remove('is-dragging');
        if (event && typeof viewport.releasePointerCapture === 'function') {
          try { viewport.releasePointerCapture(event.pointerId); } catch (error) {}
        }
        resumeAutoSoon();
      };
      viewport.addEventListener('pointerup', stopDragging);
      viewport.addEventListener('pointercancel', stopDragging);
      viewport.addEventListener('lostpointercapture', stopDragging);
      viewport.addEventListener('wheel', () => { pauseAuto(); resumeAutoSoon(); }, { passive: true });
      viewport.addEventListener('touchstart', pauseAuto, { passive: true });
      viewport.addEventListener('touchend', resumeAutoSoon, { passive: true });
    });

    document.querySelectorAll('[data-before-after]').forEach((compare) => {
      const range = compare.querySelector('[data-before-after-range]');
      if (!range) return;

      const min = Number(range.min || 0);
      const max = Number(range.max || 100);
      const clamp = (value) => Math.min(max, Math.max(min, value));
      const render = (value) => {
        const next = clamp(value);
        range.value = String(next);
        compare.style.setProperty('--split', `${next}%`);
        compare.style.setProperty('--position', `${next}%`);
      };
      const renderFromX = (clientX) => {
        const rect = compare.getBoundingClientRect();
        if (!rect.width) return;
        render(((clientX - rect.left) / rect.width) * 100);
      };
      const handle = compare.querySelector('.spine-interactive__handle');
      const isHandleTarget = (target) => !!(handle && target && handle.contains(target));
      const nearCurrentHandle = (clientX) => {
        const rect = compare.getBoundingClientRect();
        const current = Number(range.value || 50);
        const handleX = rect.left + (rect.width * current / 100);
        return Math.abs(clientX - handleX) <= 72;
      };

      render(Number(range.value || 50));

      let autoStopped = false;
      let autoDirection = 1;
      let autoValue = clamp(50);
      let autoLastTime = performance.now();
      const autoSpeed = 15;
      const stopAuto = () => {
        autoStopped = true;
        compare.classList.add('is-manual');
      };
      const autoTick = (now) => {
        const dt = Math.min(50, now - autoLastTime);
        autoLastTime = now;
        if (!autoStopped && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          autoValue += autoDirection * autoSpeed * (dt / 1000);
          if (autoValue >= max) { autoValue = max; autoDirection = -1; }
          if (autoValue <= min) { autoValue = min; autoDirection = 1; }
          render(autoValue);
        }
        requestAnimationFrame(autoTick);
      };
      autoValue = clamp(50);
      render(autoValue);
      requestAnimationFrame(autoTick);

      range.addEventListener('input', () => {
        stopAuto();
        render(Number(range.value));
      });

      let pointerId = null;
      let dragging = false;
      let startX = 0;
      let startY = 0;
      let lastX = 0;
      let moved = false;
      let immediateMode = false;

      const beginDrag = (event) => {
        dragging = true;
        compare.classList.add('is-dragging');
        compare.dataset.dragging = 'true';
        compare.setPointerCapture?.(event.pointerId);
        renderFromX(event.clientX);
        event.preventDefault();
      };

      const resetDrag = () => {
        compare.classList.remove('is-dragging');
        delete compare.dataset.dragging;
        pointerId = null;
        dragging = false;
        moved = false;
        immediateMode = false;
      };

      compare.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        stopAuto();
        pointerId = event.pointerId;
        startX = lastX = event.clientX;
        startY = event.clientY;
        moved = false;
        immediateMode = event.pointerType === 'mouse' || event.pointerType === 'pen' || isHandleTarget(event.target) || nearCurrentHandle(event.clientX);

        if (immediateMode) beginDrag(event);
      }, { passive: false });

      compare.addEventListener('pointermove', (event) => {
        if (event.pointerId !== pointerId) return;
        lastX = event.clientX;
        const dx = event.clientX - startX;
        const dy = event.clientY - startY;
        if (Math.abs(dx) > 2 || Math.abs(dy) > 2) moved = true;

        if (!dragging) {
          if (Math.abs(dx) < 4 && Math.abs(dy) < 4) return;
          if (Math.abs(dx) >= Math.abs(dy) * 0.85) {
            beginDrag(event);
          } else {
            resetDrag();
            return;
          }
        }

        renderFromX(event.clientX);
        event.preventDefault();
      }, { passive: false });

      const finishPointer = (event) => {
        if (event.pointerId !== pointerId) return;
        if (dragging) {
          renderFromX(event.clientX || lastX);
          if (compare.hasPointerCapture?.(event.pointerId)) compare.releasePointerCapture(event.pointerId);
        } else if (!moved && event.type === 'pointerup') {
          renderFromX(event.clientX || lastX);
        }
        resetDrag();
      };

      compare.addEventListener('touchstart', stopAuto, { passive: true });
      compare.addEventListener('keydown', stopAuto);
      compare.addEventListener('pointerup', finishPointer);
      compare.addEventListener('pointercancel', resetDrag);
      compare.addEventListener('lostpointercapture', () => compare.classList.remove('is-dragging'));
    });

    document.querySelectorAll('[data-anatomy]').forEach((anatomy) => {
      const cloud = anatomy.querySelector('[data-anatomy-cloud]');
      const title = anatomy.querySelector('[data-anatomy-title]');
      const copy = anatomy.querySelector('[data-anatomy-copy]');
      const hotspots = [...anatomy.querySelectorAll('[data-anatomy-hotspot]')];
      const closeCloud = () => {
        if (cloud) cloud.hidden = true;
        hotspots.forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-expanded', 'false');
        });
      };
      hotspots.forEach((hotspot) => hotspot.addEventListener('click', () => {
        const alreadyOpen = hotspot.classList.contains('is-active') && cloud && !cloud.hidden;
        if (alreadyOpen) return closeCloud();
        hotspots.forEach((item) => {
          item.classList.toggle('is-active', item === hotspot);
          item.setAttribute('aria-expanded', String(item === hotspot));
        });
        if (title) title.textContent = hotspot.dataset.title || '';
        if (copy) copy.textContent = hotspot.dataset.copy || '';
        if (cloud) cloud.hidden = false;
      }));
      anatomy.querySelector('[data-anatomy-close]')?.addEventListener('click', closeCloud);
    });

    const updateGalleryCaption = (gallery, source) => {
      if (!gallery || !source) return;
      const benefit = gallery.querySelector('[data-gallery-benefit]');
      const kicker = gallery.querySelector('[data-gallery-kicker]');
      const title = gallery.querySelector('[data-gallery-title]');
      const copy = gallery.querySelector('[data-gallery-copy]');
      const bubbleCards = [...gallery.querySelectorAll('[data-gallery-bubble]')];
      const nextTitle = source.dataset.galleryTitle || '';
      if (kicker) kicker.textContent = source.dataset.galleryKicker || 'Le conseil Pioupiou';
      if (title) title.textContent = nextTitle;
      if (copy) copy.textContent = source.dataset.galleryCopy || '';
      bubbleCards.forEach((card) => {
        const index = card.dataset.galleryBubble;
        const icon = card.querySelector('[data-bubble-icon]');
        const bubbleTitle = card.querySelector('[data-bubble-title]');
        const bubbleCopy = card.querySelector('[data-bubble-copy]');
        const titleValue = source.dataset[`bubble${index}Title`] || '';
        const copyValue = source.dataset[`bubble${index}Copy`] || '';
        const iconValue = source.dataset[`bubble${index}Icon`] || '✦';
        const hasContent = Boolean(titleValue || copyValue);
        card.hidden = !hasContent;
        if (icon) icon.textContent = iconValue;
        if (bubbleTitle) bubbleTitle.textContent = titleValue;
        if (bubbleCopy) bubbleCopy.textContent = copyValue;
      });
      if (benefit) {
        benefit.hidden = !nextTitle;
      }
    };

    document.querySelectorAll('[data-auto-gallery]').forEach((gallery) => {
      const mainImage = gallery.querySelector('[data-main-product-image]');
      const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
      const note = gallery.querySelector('.gallery-note');
      const stage = gallery.querySelector('[data-gallery-stage]');
      const previousImage = gallery.querySelector('[data-gallery-prev]');
      const nextImage = gallery.querySelector('[data-gallery-next]');
      const counter = gallery.querySelector('[data-gallery-counter]');
      let galleryIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));
      let touchStartX = 0;
      let touchStartY = 0;

      const stopAuto = () => {
        gallery.classList.remove('is-playing');
      };
      const showGalleryImage = (index, manual = false) => {
        const thumb = thumbs[index];
        if (!mainImage || !thumb?.dataset.src) return;
        galleryIndex = index;
        if (thumb.dataset.srcset) mainImage.setAttribute('srcset', thumb.dataset.srcset);
        else mainImage.removeAttribute('srcset');
        if (thumb.dataset.sizes) mainImage.setAttribute('sizes', thumb.dataset.sizes);
        else mainImage.removeAttribute('sizes');
        mainImage.src = thumb.dataset.src;
        mainImage.alt = thumb.dataset.galleryAlt || thumb.getAttribute('aria-label') || mainImage.alt;
        mainImage.classList.toggle('is-cover-fit', thumb.dataset.galleryFit === 'cover');
        updateGalleryCaption(gallery, thumb);
        thumbs.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === index));
        if (counter) counter.textContent = `${index + 1} / ${thumbs.length}`;
        stopAuto();
        if (manual && note) {
          note.textContent = 'Image sélectionnée · utilisez les vignettes pour voir une autre vue';
        }
      };
      const showPack = (source, image) => {
        stopAuto();
        if (mainImage && image?.src) {
          mainImage.removeAttribute('srcset');
          mainImage.removeAttribute('sizes');
          mainImage.src = image.src;
          mainImage.alt = image.alt || 'Pack Pioupiou';
          mainImage.classList.remove('is-cover-fit');
        }
        thumbs.forEach((item) => item.classList.remove('is-active'));
        updateGalleryCaption(gallery, source);
        if (note) note.textContent = 'Pack s\u00e9lectionn\u00e9 \u00b7 les conseils restent sous la photo';
      };

      const showRelative = (delta) => {
        if (!thumbs.length) return;
        const nextIndex = (galleryIndex + delta + thumbs.length) % thumbs.length;
        showGalleryImage(nextIndex, true);
      };

      thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showGalleryImage(index, true)));
      previousImage?.addEventListener('click', () => showRelative(-1));
      nextImage?.addEventListener('click', () => showRelative(1));

      stage?.addEventListener('touchstart', (event) => {
        const touch = event.changedTouches?.[0];
        if (!touch) return;
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
      }, { passive: true });
      stage?.addEventListener('touchend', (event) => {
        const touch = event.changedTouches?.[0];
        if (!touch) return;
        const dx = touch.clientX - touchStartX;
        const dy = touch.clientY - touchStartY;
        if (Math.abs(dx) < 44 || Math.abs(dx) <= Math.abs(dy)) return;
        showRelative(dx < 0 ? 1 : -1);
      }, { passive: true });

      if (thumbs[galleryIndex]) {
        updateGalleryCaption(gallery, thumbs[galleryIndex]);
        if (counter) counter.textContent = `${galleryIndex + 1} / ${thumbs.length}`;
      }
      stopAuto();
      if (note) note.textContent = 'Faites glisser l’image ou utilisez les flèches';
      galleryStates.set(gallery, { showPack, showGalleryImage, stopAuto });
    });



    /* V50 — Shopify/Chrome peut restaurer une ancienne position horizontale.
       On démarre toujours la galerie produit mobile sur la première image. */
    const resetMobileProductStrips = () => {
      if (!window.matchMedia('(max-width: 760px)').matches) return;
      document.querySelectorAll('[data-mobile-product-strip]').forEach((strip) => {
        strip.scrollTo({ left: 0, behavior: 'auto' });
      });
    };
    window.requestAnimationFrame(() => window.requestAnimationFrame(resetMobileProductStrips));
    window.addEventListener('pageshow', resetMobileProductStrips);
    window.addEventListener('orientationchange', () => window.setTimeout(resetMobileProductStrips, 120));
    let productStripResizeTimer = null;
    window.addEventListener('resize', () => {
      window.clearTimeout(productStripResizeTimer);
      productStripResizeTimer = window.setTimeout(resetMobileProductStrips, 140);
    }, { passive: true });

    document.querySelectorAll('[data-review-pagination]').forEach((section) => {
      const list = section.querySelector('[data-review-list]');
      const deferredTemplate = section.querySelector('[data-review-card-templates]');
      const initialCards = list ? [...list.querySelectorAll('[data-review-card]')] : [];
      const deferredCards = deferredTemplate ? [...deferredTemplate.content.querySelectorAll('[data-review-card]')] : [];
      const cards = [...initialCards, ...deferredCards];
      const previous = section.querySelector('[data-review-prev]');
      const next = section.querySelector('[data-review-next]');
      const pages = section.querySelector('[data-review-pages]');
      const status = section.querySelector('[data-review-status]');
      if (!list || !cards.length || !previous || !next || !pages) return;

      let currentPage = 1;
      let itemsPerPage = window.matchMedia('(max-width: 760px)').matches ? 4 : 6;

      const pageTokens = (totalPages) => {
        if (totalPages <= 7) return Array.from({ length: totalPages }, (_, index) => index + 1);
        const tokens = [1];
        const start = Math.max(2, currentPage - 1);
        const end = Math.min(totalPages - 1, currentPage + 1);
        if (start > 2) tokens.push('ellipsis-start');
        for (let page = start; page <= end; page += 1) tokens.push(page);
        if (end < totalPages - 1) tokens.push('ellipsis-end');
        tokens.push(totalPages);
        return tokens;
      };

      const render = ({ announce = false } = {}) => {
        const totalPages = Math.max(1, Math.ceil(cards.length / itemsPerPage));
        currentPage = Math.min(Math.max(1, currentPage), totalPages);
        const firstIndex = (currentPage - 1) * itemsPerPage;
        const lastIndex = firstIndex + itemsPerPage;

        list.querySelectorAll('[data-review-card]').forEach((card) => card.remove());
        cards.slice(firstIndex, lastIndex).forEach((card) => {
          card.hidden = false;
          card.classList.add('is-visible');
          list.appendChild(card);
        });

        previous.disabled = currentPage === 1;
        next.disabled = currentPage === totalPages;
        pages.replaceChildren();

        pageTokens(totalPages).forEach((token) => {
          if (typeof token !== 'number') {
            const ellipsis = document.createElement('span');
            ellipsis.className = 'review-pagination__ellipsis';
            ellipsis.textContent = '…';
            ellipsis.setAttribute('aria-hidden', 'true');
            pages.appendChild(ellipsis);
            return;
          }
          const button = document.createElement('button');
          button.type = 'button';
          button.textContent = String(token);
          button.setAttribute('aria-label', `Afficher la page ${token} des avis`);
          if (token === currentPage) button.setAttribute('aria-current', 'page');
          button.addEventListener('click', () => {
            if (token === currentPage) return;
            currentPage = token;
            render({ announce: true });
          });
          pages.appendChild(button);
        });

        if (status) status.textContent = `Page ${currentPage} sur ${totalPages}`;
        if (announce) {
          const gridTop = section.querySelector('[data-review-list]')?.getBoundingClientRect().top ?? 0;
          if (gridTop < 90) section.querySelector('.reviews-heading')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      };

      previous.addEventListener('click', () => {
        if (currentPage <= 1) return;
        currentPage -= 1;
        render({ announce: true });
      });
      next.addEventListener('click', () => {
        const totalPages = Math.max(1, Math.ceil(cards.length / itemsPerPage));
        if (currentPage >= totalPages) return;
        currentPage += 1;
        render({ announce: true });
      });

      let resizeFrame;
      window.addEventListener('resize', () => {
        if (resizeFrame) window.cancelAnimationFrame(resizeFrame);
        resizeFrame = window.requestAnimationFrame(() => {
          const nextItemsPerPage = window.matchMedia('(max-width: 760px)').matches ? 4 : 6;
          if (nextItemsPerPage === itemsPerPage) return;
          const firstVisibleIndex = (currentPage - 1) * itemsPerPage;
          itemsPerPage = nextItemsPerPage;
          currentPage = Math.floor(firstVisibleIndex / itemsPerPage) + 1;
          render();
        });
      });

      render();
    });

    } catch (e) {
      console.error('[Pioupiou] Bloc décoratif en erreur — isolé, achat non impacté :', e);
    }

    const sizeSummaryMap = {
      '1-3': '50 × 30 × 2 cm',
      '3-8': '50 × 30 × 4 cm',
      '8-14': '54 × 32 × 6 cm'
    };

    document.querySelectorAll('[data-product-section]').forEach((section) => {
      const productScript = section.querySelector('[data-bundle-products]');
      const variantMapScript = section.querySelector('[data-direct-variant-map]');
      const giftCoverProductScript = section.querySelector('[data-gift-cover-product]');
      let products = {};
      let directVariantMap = {};
      let giftCoverProduct = null;
      try { products = productScript ? JSON.parse(productScript.textContent) : {}; } catch (_) { products = {}; }
      try { directVariantMap = variantMapScript ? JSON.parse(variantMapScript.textContent) : {}; } catch (_) { directVariantMap = {}; }
      directVariantMap = {
        '1-3': Number(directVariantMap['1-3'] || 58458933035272),
        '3-8': Number(directVariantMap['3-8'] || 58458933068040),
        '8-14': Number(directVariantMap['8-14'] || 58458933100808)
      };
      try { giftCoverProduct = giftCoverProductScript ? JSON.parse(giftCoverProductScript.textContent) : null; } catch (_) { giftCoverProduct = null; }

      const packButtons = [...section.querySelectorAll('[data-pack-button]')];
      const packGrid = section.querySelector('.pack-grid');
      const packInlineEditor = section.querySelector('[data-pack-inline-editor]');
      const sizeButtons = [...section.querySelectorAll('[data-variant-button]')];
      const sizeSelect = section.querySelector('[data-size-select]');
      const sizeChips = [...section.querySelectorAll('[data-size-chip]')];
      const bundleSizeChips = [...section.querySelectorAll('[data-bundle-size-chip]')];
      const sizePicker = section.querySelector('[data-size-picker]');
      const sizePickerLegend = section.querySelector('[data-size-picker-legend]');
      const sizePickerHint = section.querySelector('[data-size-picker-hint]');
      const sizeFlowInfo = section.querySelector('[data-size-flow-info]');
      const sizeFlowTitle = section.querySelector('[data-size-flow-title]');
      const sizeFlowCopy = section.querySelector('[data-size-flow-copy]');
      const singleSizePicker = section.querySelector('[data-single-size-picker]');
      const bundleSizePicker = section.querySelector('[data-bundle-size-picker]');
      const bundleSizeList = section.querySelector('[data-bundle-size-list]');
      const bundleSizeRows = [...section.querySelectorAll('[data-bundle-size-row]')];
      const bundleSizeSelects = [...section.querySelectorAll('[data-bundle-size-select]')];
      const multiSizeNote = section.querySelector('[data-multi-size-note]');
      const multiSizeNoteText = section.querySelector('[data-multi-size-note-text]');
      const customizeSizesButton = section.querySelector('[data-customize-sizes]');
      const customizeSizesClose = section.querySelector('[data-customize-sizes-close]');
      const giftCoverPicker = section.querySelector('[data-gift-cover-picker]');
      const giftCoverTitle = section.querySelector('[data-gift-cover-title]');
      const giftCoverSubtitle = section.querySelector('[data-gift-cover-subtitle]');
      const giftCoverChoiceHint = section.querySelector('[data-gift-cover-choice-hint]');
      const giftCoverRows = [...section.querySelectorAll('[data-gift-cover-row]')];
      const giftCoverSelects = [...section.querySelectorAll('[data-gift-cover-select]')];
      const giftCoverChoices = [...section.querySelectorAll('[data-gift-cover-choice]')];
      const giftCoverAgeSelects = [...section.querySelectorAll('[data-gift-cover-age-select]')];
      const packSummaryTitle = section.querySelector('[data-pack-summary-title]');
      const packSummaryCopy = section.querySelector('[data-pack-summary-copy]');
      const variantInput = section.querySelector('[data-variant-input]');
      const quantityInput = section.querySelector('[data-quantity]');
      const price = section.querySelector('[data-product-price]');
      const comparePrice = section.querySelector('[data-compare-price]');
      const saving = section.querySelector('[data-saving-badge]');
      const unitPrice = section.querySelector('[data-unit-price]');
      const addButton = section.querySelector('[data-add-to-cart]');
      const addText = section.querySelector('[data-add-text]');
      const mobileSticky = section.querySelector('[data-mobile-sticky]');
      const mobilePrice = section.querySelector('[data-mobile-price]');
      const mobileImage = mobileSticky?.querySelector('img');
      const mobileAdd = section.querySelector('[data-mobile-add]');
      const productForm = section.querySelector('[data-ajax-product-form]');
      const productFeedback = productForm?.querySelector('[data-cart-feedback]');
      const gallery = section.querySelector('[data-auto-gallery]');
      const galleryState = galleryStates.get(gallery);
      const sizeSummary = section.querySelector('[data-size-summary]');
      const sizePanelTitle = section.querySelector('[data-size-panel-title]');
      const sizePanelCopy = section.querySelector('[data-size-panel-copy]');

      let packKey = packButtons.find((button) => button.classList.contains('is-selected'))?.dataset.packKey || '1';
      let sizeTitle = sizeSelect?.value || sizeButtons.find((button) => button.classList.contains('is-selected'))?.dataset.variantTitle || '3 à 8 ans';
      let customizingSizes = false;
      let previousPackQuantity = Math.max(1, Number.parseInt(packButtons.find((button) => button.dataset.packKey === packKey)?.dataset.packQuantity || packKey || '1', 10) || 1);

      const normalized = (value) => String(value || '')
        .trim()
        .toLowerCase()
        .replace(/[–—−]/g, '-')
        .replace(/\s+/g, ' ');
      const ageKey = (value) => {
        const numbers = normalized(value).match(/\d+/g) || [];
        if (numbers.length < 2) return '';
        const key = `${numbers[0]}-${numbers[1]}`;
        return ['1-3', '3-8', '8-14'].includes(key) ? key : '';
      };
      const findVariant = (variants, requestedTitle) => {
        const requestedAge = ageKey(requestedTitle);
        return variants.find((item) => item.available && requestedAge && ageKey(item.title) === requestedAge)
          || variants.find((item) => item.available && normalized(item.title) === normalized(requestedTitle))
          || variants.find((item) => item.available)
          || variants[0];
      };

      const selectedPackQuantity = () => {
        const packButton = packButtons.find((button) => button.dataset.packKey === packKey) || packButtons[0];
        return Math.max(1, Number.parseInt(packButton?.dataset.packQuantity || packKey || '1', 10) || 1);
      };

      const clearEditParams = () => {
        try {
          const url = new URL(window.location.href);
          ['edit', 'pack', 'ages', 'gift1', 'giftAge1', 'gift2', 'giftAge2', 'gift3', 'giftAge3'].forEach((key) => url.searchParams.delete(key));
          if (window.history?.replaceState) window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
        } catch (_) {}
      };
      const announceSelectionReady = (message) => {
        if (productFeedback) productFeedback.textContent = message;
      };

      const positionInlineEditor = (packButton) => {
        if (!packGrid || !packInlineEditor || !packButton) return;
        if (packButton.nextElementSibling !== packInlineEditor) packButton.insertAdjacentElement('afterend', packInlineEditor);
        packInlineEditor.classList.remove('is-arriving');
        window.requestAnimationFrame(() => packInlineEditor.classList.add('is-arriving'));
      };

      const syncPressedGroup = (buttons, value) => {
        buttons.forEach((chip) => {
          const active = chip.dataset.value === value;
          chip.classList.toggle('is-active', active);
          chip.setAttribute('aria-pressed', String(active));
        });
      };

      const formatAgeCompact = (value) => String(value || '').replace(' à ', '–').replace(' ans', '');
      const updatePackSummary = () => {
        const quantity = selectedPackQuantity();
        const ages = quantity > 1
          ? bundleSizeSelects.slice(0, quantity).map((select) => formatAgeCompact(select.value))
          : [formatAgeCompact(String(sizeSelect?.value || sizeTitle))];
        const gifts = quantity >= 2
          ? giftCoverSelects.slice(0, quantity - 1).map((select, index) => {
              const ageSelect = giftCoverAgeSelects[index];
              const giftAge = ageSelect?.value ? formatAgeCompact(ageSelect.value) : '';
              return giftAge ? `${select.value} (${giftAge} ans)` : select.value;
            })
          : [];
        const uniqueAges = [...new Set(ages)];
        const sameAge = uniqueAges.length === 1;
        if (packSummaryTitle) {
          packSummaryTitle.textContent = quantity > 1
            ? `${quantity} oreillers · ${sameAge ? `${uniqueAges[0]} ans × ${quantity}` : ages.map((age, index) => `${index + 1}:${age}`).join(' · ')}`
            : `1 oreiller · ${ages[0]} ans`;
        }
        if (packSummaryCopy) {
          if (gifts.length) {
            packSummaryCopy.textContent = `Housse${gifts.length > 1 ? 's' : ''} offerte${gifts.length > 1 ? 's' : ''} : ${gifts.join(' + ')}`;
          } else if (quantity > 1 && !sameAge) {
            packSummaryCopy.textContent = ages.map((age, index) => `Oreiller ${index + 1} : ${age} ans`).join(' · ');
          } else {
            packSummaryCopy.textContent = 'Configuration prête à commander';
          }
        }
      };

      const syncBundleSizesToShared = () => {
        const sharedValue = sizeSelect?.value || sizeTitle || '3 à 8 ans';
        bundleSizeSelects.forEach((select) => { select.value = sharedValue; });
      };

      /* V10.73 — le pack famille n'a plus de plafond visible.
         Les lignes d'âge sont créées à la demande, uniquement si le client ouvre
         « Des âges différents ? », afin de garder l'interface légère. */
      const ensureBundleSizeRows = (quantity) => {
        if (!bundleSizeList) return;
        const target = Math.max(1, Number.parseInt(quantity || '1', 10) || 1);
        while (bundleSizeSelects.length < target) {
          const index = bundleSizeSelects.length + 1;
          const row = document.createElement('label');
          const selectId = `BundleSizeSelectDynamic${index}-${Math.random().toString(36).slice(2, 7)}`;
          row.className = 'bundle-size-row bundle-size-row--select';
          row.dataset.bundleSizeRow = '';
          row.dataset.bundleSizeIndex = String(index);
          row.setAttribute('for', selectId);
          row.hidden = true;
          row.innerHTML = `<span class="bundle-size-row__label"><b>${index}</b><span><strong>Oreiller ${index}</strong></span></span><span class="bundle-size-select-wrap"><select id="${selectId}" class="bundle-size-select--visible" data-bundle-size-select aria-label="Taille de l’oreiller ${index}"><option value="1 à 3 ans">1–3 ans</option><option value="3 à 8 ans" selected>3–8 ans</option><option value="8 à 14 ans">8–14 ans</option></select><span aria-hidden="true">⌄</span></span>`;
          bundleSizeList.appendChild(row);
          const select = row.querySelector('[data-bundle-size-select]');
          if (!select) break;
          select.value = sizeSelect?.value || sizeTitle || '3 à 8 ans';
          select.addEventListener('change', () => { clearEditParams(); updateSelection(); });
          bundleSizeRows.push(row);
          bundleSizeSelects.push(select);
        }
      };

      /* V10.30 — un age partage par defaut, y compris sur un pack.
         Le detail par oreiller ne s'affiche que si le client le demande :
         une decision au lieu de quatre. */
      const syncSizePickerMode = () => {
        const quantity = selectedPackQuantity();
        const multi = quantity > 1;
        const detailed = multi && customizingSizes;
        if (detailed) ensureBundleSizeRows(quantity);
        if (!multi) customizingSizes = false;
        if (singleSizePicker) singleSizePicker.hidden = detailed;
        if (multiSizeNote) multiSizeNote.hidden = true;
        if (bundleSizePicker) bundleSizePicker.hidden = !detailed;
        if (customizeSizesButton) {
          customizeSizesButton.hidden = !multi || detailed;
          const label = customizeSizesButton.querySelector('[data-customize-sizes-label]');
          if (label) label.textContent = `Des âges différents pour les ${quantity} oreillers ?`;
        }
        if (sizePickerLegend) {
          sizePickerLegend.textContent = multi
            ? (detailed ? '2. Âge de chaque oreiller' : '2. Quel âge ont vos enfants ?')
            : '2. Quel âge a votre enfant ?';
        }
        if (sizePickerHint) {
          sizePickerHint.hidden = false;
          sizePickerHint.textContent = multi && !detailed
            ? `Cet âge s’applique aux ${quantity} oreillers.`
            : 'Choisissez l’âge de votre enfant.';
        }
        if (sizeFlowInfo) sizeFlowInfo.hidden = true;
        if (sizePicker) {
          sizePicker.classList.toggle('size-picker--bundle', multi);
          sizePicker.classList.toggle('is-customizing-sizes', detailed);
        }
        bundleSizeRows.forEach((row, index) => { row.hidden = !detailed || index >= quantity; });
        /* Tant que le client n'a pas ouvert le detail, les oreillers suivent l'age partage. */
        if (multi && !detailed) syncBundleSizesToShared();
      };


      const syncGiftCoverAgeTargets = () => {
        const quantity = selectedPackQuantity();
        const defaultAges = quantity > 1
          ? bundleSizeSelects.slice(0, quantity).map((select) => select.value || '3 à 8 ans')
          : [sizeSelect?.value || sizeTitle || '3 à 8 ans'];
        giftCoverAgeSelects.forEach((select, index) => {
          if (!select) return;
          const targetAge = defaultAges[index] || defaultAges[0] || '3 à 8 ans';
          if (!select.dataset.userChosen || !select.value) select.value = targetAge;
        });
      };

      const syncGiftCoverMode = () => {
        const quantity = selectedPackQuantity();
        /* V10.73 — pour 1 à 4, le comportement historique reste identique.
           Au-delà, le nombre de housses suit la combinaison de packs Shopify utilisée. */
        const selectedPack = packButtons.find((button) => button.dataset.packKey === packKey) || packButtons.find((button) => button.classList.contains('is-selected'));
        const configuredGifts = Number.parseInt(selectedPack?.dataset.packGifts || '', 10);
        const giftCount = Number.isFinite(configuredGifts) ? Math.max(0, configuredGifts) : Math.max(0, quantity - 1);
        if (giftCoverPicker) giftCoverPicker.hidden = giftCount === 0;
        if (giftCoverTitle) {
          giftCoverTitle.textContent = giftCount > 1
            ? `${giftCount} housses offertes incluses`
            : '1 housse offerte incluse';
        }
        /* V10.32 — le sous-titre annonce ce qui est DEJA choisi, et la valeur du cadeau
           est recalculee sur le nombre de housses du pack. */
        if (giftCoverSubtitle) {
          const motifs = giftCoverSelects.slice(0, giftCount).map((select) => select.value).filter(Boolean);
          giftCoverSubtitle.textContent = motifs.length
            ? `${motifs.join(' · ')} — modifiez si vous voulez`
            : 'Déjà choisie pour vous — modifiez si vous voulez';
        }
        const giftValue = section.querySelector('[data-gift-cover-value]');
        if (giftValue) {
          const giftUnitPrice = Math.max(0, Number.parseInt(giftCoverPicker?.dataset.giftCoverUnitPrice || document.body?.dataset?.pioupiouCoverUpsellPrice || '999', 10) || 999);
          const struck = giftValue.querySelector('s');
          if (struck) struck.textContent = `${((giftUnitPrice * Math.max(1, giftCount)) / 100).toFixed(2).replace('.', ',')} €`;
        }
        giftCoverRows.forEach((row, index) => { row.hidden = index >= Math.min(giftCount, giftCoverRows.length); });
        if (giftCoverChoiceHint) {
          giftCoverChoiceHint.textContent = giftCount > giftCoverRows.length
            ? `${giftCoverRows.length} motifs personnalisables ici · les housses suivantes reprennent ces choix automatiquement.`
            : 'Deux motifs au choix, taille alignée sur l’oreiller.';
        }
        syncGiftCoverAgeTargets();
      };

      const bundleVariantsAvailable = () => {
        const quantity = selectedPackQuantity();
        if (quantity <= 1) return true;
        const sourceProduct = products['1'] || products[packKey];
        const variants = sourceProduct?.variants || [];
        const variantAvailableForAge = (age) => {
          const key = ageKey(age);
          const mappedId = directVariantMap[key] ? String(directVariantMap[key]) : '';
          const variant = variants.find((item) => String(item.id) === mappedId) || findVariant(variants, age);
          return Boolean(variant && variant.available !== false);
        };
        if (!customizingSizes) return variantAvailableForAge(sizeSelect?.value || sizeTitle || '3 à 8 ans');
        ensureBundleSizeRows(quantity);
        return bundleSizeSelects.slice(0, quantity).every((select) => variantAvailableForAge(select.value));
      };

      const updateSelection = () => {
        const packButton = packButtons.find((button) => button.dataset.packKey === packKey) || packButtons[0];
        positionInlineEditor(packButton);
        const sourceProduct = products['1'] || products[packKey];
        const variants = sourceProduct?.variants || [];
        const requestedKey = ageKey(sizeTitle) || '3-8';
        const mappedId = directVariantMap[requestedKey] ? String(directVariantMap[requestedKey]) : '';
        const variant = variants.find((item) => String(item.id) === mappedId) || findVariant(variants, sizeTitle);
        const unavailable = !variant || variant.available === false;
        const quantity = selectedPackQuantity();
        const multi = quantity > 1;
        syncSizePickerMode();
        syncGiftCoverMode();
        syncPressedGroup(sizeChips, sizeSelect?.value || sizeTitle);
        bundleSizeSelects.forEach((select, index) => {
          syncPressedGroup(bundleSizeChips.filter((chip) => Number(chip.dataset.bundleSizeIndex) === index + 1), select.value);
        });

        if (sizePanelTitle) sizePanelTitle.textContent = '';
        if (sizePanelCopy) sizePanelCopy.textContent = '';

        if (variantInput) variantInput.value = variant ? String(variant.id) : '';
        if (quantityInput && packButton) quantityInput.value = multi ? '1' : (packButton.dataset.packQuantity || '1');
        if (price && packButton) price.textContent = packButton.dataset.packPrice || '';
        if (comparePrice && packButton) {
          const compareValue = packButton.dataset.packCompare || '';
          comparePrice.textContent = compareValue;
          comparePrice.hidden = !compareValue;
        }
        if (saving && packButton) saving.textContent = packButton.dataset.packSaving || '';
        if (unitPrice && packButton) unitPrice.textContent = packButton.dataset.packUnitPrice || packButton.dataset.packPrice || '';
        if (mobilePrice && packButton) mobilePrice.textContent = packButton.dataset.packPrice;
        /* V137 mobile : le sticky reflète toujours le pack réellement sélectionné,
           sans modifier l'image principale de la galerie produit. */
        if (mobileImage && packButton) {
          const selectedPackImage = packButton.querySelector('.pack-card__image img');
          if (selectedPackImage?.src) {
            mobileImage.removeAttribute('srcset');
            mobileImage.src = selectedPackImage.currentSrc || selectedPackImage.src;
            mobileImage.alt = selectedPackImage.alt || `Pack Pioupiou ${quantity} oreiller${quantity > 1 ? 's' : ''}`;
          }
        }
        if (sizeSummary) {
          if (!multi) {
            sizeSummary.textContent = sizeSummaryMap[ageKey(sizeTitle)] || sizeSummaryMap['3-8'];
          } else if (!customizingSizes) {
            const sharedSummary = sizeSummaryMap[ageKey(sizeSelect?.value || sizeTitle)] || sizeSummaryMap['3-8'];
            sizeSummary.textContent = `${sharedSummary} × ${quantity}`;
          } else {
            ensureBundleSizeRows(quantity);
            sizeSummary.textContent = bundleSizeSelects.slice(0, quantity).map((select, index) => `O${index + 1}: ${sizeSummaryMap[ageKey(select.value)] || sizeSummaryMap['3-8']}`).join(' · ');
          }
        }
        const selectionUnavailable = multi ? !bundleVariantsAvailable() : unavailable;
        const ctaLabel = selectionUnavailable
          ? 'Indisponible'
          : 'Commander maintenant';
        if (addText) addText.textContent = ctaLabel;
        if (mobileAdd) mobileAdd.textContent = ctaLabel;
        if (addButton) addButton.disabled = selectionUnavailable;
        if (mobileAdd) mobileAdd.disabled = selectionUnavailable;
        updatePackSummary();
      };

      const selectPackButton = (button, { announce = true } = {}) => {
        if (!button) return;
        clearEditParams();
        const oldQuantity = previousPackQuantity;
        packKey = button.dataset.packKey;
        const nextQuantity = Math.max(1, Number.parseInt(button.dataset.packQuantity || packKey || '1', 10) || 1);
        customizingSizes = false;
        packButtons.forEach((item) => {
          const selected = item === button;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', String(selected));
        });
        if (nextQuantity > 1 && oldQuantity === 1) syncBundleSizesToShared();
        previousPackQuantity = nextQuantity;
        if (announce) announceSelectionReady('Nouveau pack sélectionné. Votre ancien panier sera remplacé automatiquement au clic sur Commander.');
        /* Le bundle ne remplace jamais l'image principale de la galerie. */
        updateSelection();
      };

      const familyPack = section.querySelector('[data-family-pack]');
      const familyMinus = familyPack?.querySelector('[data-family-minus]');
      const familyPlus = familyPack?.querySelector('[data-family-plus]');
      const familyCount = familyPack?.querySelector('[data-family-count]');
      const moneyForFamily = (cents) => {
        const currency = window.Shopify?.currency?.active || 'EUR';
        return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', { style: 'currency', currency }).format(Math.max(0, Number(cents || 0)) / 100);
      };
      const familyExtraPriceCents = Math.max(0, Number(document.body?.getAttribute('data-pioupiou-extra-price') || 3750));
      const familyPriceCents = (requestedQuantity) => {
        const quantity = Math.max(3, Math.floor(Number(requestedQuantity || 3)));
        const ds = document.body?.dataset || {};
        const prices = {
          1: Number(ds.pioupiouPrice1 || 5999),
          2: Number(ds.pioupiouPrice2 || 8999),
          3: Number(ds.pioupiouPrice3 || 11999),
          4: Number(ds.pioupiouPrice4 || 14999)
        };
        if (quantity <= 4) return Number(prices[quantity] || prices[1] * quantity);
        return Number(prices[4] || 14999) + ((quantity - 4) * familyExtraPriceCents);
      };
      const setFamilyPackQuantity = (requestedQuantity, { select = true, announce = true } = {}) => {
        if (!familyPack) return;
        const quantity = Math.max(3, Math.floor(Number(requestedQuantity || 3)));
        const key = String(quantity);
        const totalCents = familyPriceCents(quantity);
        const baseUnit = Number(document.body?.dataset?.pioupiouPrice1 || 5999);
        const compareCents = baseUnit * quantity;
        const savingPct = compareCents > 0 ? Math.max(0, Math.round(((compareCents - totalCents) / compareCents) * 100)) : 0;
        const giftCount = quantity <= 4 ? Math.max(0, quantity - 1) : 3;
        familyPack.dataset.packKey = key;
        familyPack.dataset.packQuantity = key;
        familyPack.dataset.packGifts = String(giftCount);
        familyPack.dataset.packPlan = quantity <= 4 ? key : `4+${quantity - 4} supplément${quantity - 4 > 1 ? 's' : ''}`;
        familyPack.dataset.packPrice = moneyForFamily(totalCents);
        familyPack.dataset.packCompare = compareCents > totalCents ? moneyForFamily(compareCents) : '';
        familyPack.dataset.packSaving = savingPct > 0 ? `Économisez ${savingPct} %` : '';
        familyPack.setAttribute('aria-label', `Pack famille, ${quantity} oreillers. Utilisez moins ou plus pour ajuster le nombre d’oreillers.`);
        if (familyCount) familyCount.textContent = key;

        const title = familyPack.querySelector('[data-family-title]');
        const priceText = familyPack.querySelector('[data-family-price-text]');
        const compareText = familyPack.querySelector('[data-family-compare-text]');
        const savingText = familyPack.querySelector('[data-family-saving]');
        const giftText = familyPack.querySelector('[data-family-gift]');
        const badge = familyPack.querySelector('[data-family-badge]');
        const image = familyPack.querySelector('[data-family-image]');
        if (title) title.textContent = 'Toute la fratrie';
        if (priceText) priceText.textContent = familyPack.dataset.packPrice;
        if (compareText) {
          compareText.textContent = familyPack.dataset.packCompare || '';
          compareText.hidden = !familyPack.dataset.packCompare;
        }
        if (savingText) savingText.textContent = familyPack.dataset.packSaving;
        if (giftText) giftText.textContent = giftCount > 0
          ? `Livraison offerte · + ${giftCount} housse${giftCount > 1 ? 's' : ''} offerte${giftCount > 1 ? 's' : ''}`
          : 'Livraison offerte';
        if (badge) badge.textContent = 'Meilleure offre';
        if (image) {
          const nextImage = quantity === 3
            ? familyPack.dataset.familyImage3
            : quantity === 4
              ? familyPack.dataset.familyImage4
              : (familyPack.dataset.familyImage5plus || familyPack.dataset.familyImage4);
          if (nextImage) { image.removeAttribute('srcset'); image.src = nextImage; }
          image.alt = quantity > 4 ? 'Pack famille Pioupiou, quantité libre' : `${quantity} oreillers Pioupiou`;
        }
        if (familyMinus) familyMinus.disabled = quantity <= 3;
        if (familyPlus) familyPlus.disabled = false;

        if (select) selectPackButton(familyPack, { announce });
        else if (familyPack.classList.contains('is-selected')) {
          packKey = key;
          previousPackQuantity = quantity;
          updateSelection();
        }
      };

      packButtons.forEach((button) => button.addEventListener('click', (event) => {
        if (event.target?.closest?.('[data-family-stepper]')) return;
        selectPackButton(button);
      }));
      familyPack?.addEventListener('keydown', (event) => {
        if (event.target?.closest?.('[data-family-stepper]')) return;
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          selectPackButton(familyPack);
        }
      });
      familyMinus?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        setFamilyPackQuantity(Math.max(3, Number(familyPack?.dataset?.packQuantity || 3) - 1));
      });
      familyPlus?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        setFamilyPackQuantity(Number(familyPack?.dataset?.packQuantity || 3) + 1);
      });
      if (familyPack) setFamilyPackQuantity(Number(familyPack.dataset.packQuantity || 3), { select: false, announce: false });

      sizeButtons.forEach((button) => button.addEventListener('click', () => {
        clearEditParams();
        if (button.disabled) return;
        sizeTitle = button.dataset.variantTitle || '';
        sizeButtons.forEach((item) => item.classList.toggle('is-selected', item === button));
        updateSelection();
      }));

      sizeSelect?.addEventListener('change', () => {
        clearEditParams();
        sizeTitle = sizeSelect.value;
        if (!customizingSizes) syncBundleSizesToShared();
        updateSelection();
      });
      sizeChips.forEach((chip) => chip.addEventListener('click', () => {
        clearEditParams();
        if (!sizeSelect) return;
        sizeSelect.value = chip.dataset.value || sizeSelect.value;
        sizeTitle = sizeSelect.value;
        syncPressedGroup(sizeChips, sizeSelect.value);
        if (!customizingSizes) syncBundleSizesToShared();
        updateSelection();
      }));

      customizeSizesButton?.addEventListener('click', () => {
        customizingSizes = true;
        updateSelection();
      });
      customizeSizesClose?.addEventListener('click', () => {
        customizingSizes = false;
        syncBundleSizesToShared();
        updateSelection();
      });

      bundleSizeSelects.forEach((select) => select.addEventListener('change', () => { clearEditParams(); updateSelection(); }));
      bundleSizeChips.forEach((chip) => chip.addEventListener('click', () => {
        clearEditParams();
        const index = Number(chip.dataset.bundleSizeIndex || 0);
        const select = bundleSizeSelects[index - 1];
        if (!select) return;
        select.value = chip.dataset.value || select.value;
        syncPressedGroup(bundleSizeChips.filter((item) => Number(item.dataset.bundleSizeIndex) === index), select.value);
        updateSelection();
      }));

      const syncGiftCoverSelect = (select) => {
        if (!select) return;
        const selectedOption = select.options?.[select.selectedIndex];
        const exactVariantId = selectedOption?.dataset?.variantId || '';
        const requested = normalized(select.value);
        const giftVariants = giftCoverProduct?.variants || [];
        const matchedVariant = giftVariants.find((variant) => normalized(variant.title) === requested)
          || giftVariants.find((variant) => normalized(variant.title).includes(requested) || requested.includes(normalized(variant.title)));
        select.dataset.selectedCover = select.value;
        select.dataset.selectedVariantId = matchedVariant?.id ? String(matchedVariant.id) : exactVariantId;
        const row = select.closest('[data-gift-cover-row]');
        row?.setAttribute('data-cover-choice', normalized(select.value).replace(/[^a-z0-9]+/g, '-'));
        row?.querySelectorAll('[data-gift-cover-choice]').forEach((choice) => {
          const active = choice.dataset.coverValue === select.value;
          choice.classList.toggle('is-active', active);
          choice.setAttribute('aria-pressed', String(active));
        });
      };
      giftCoverSelects.forEach((select) => {
        syncGiftCoverSelect(select);
        select.addEventListener('change', () => {
          clearEditParams();
          syncGiftCoverSelect(select);
          updatePackSummary();
        });
      });
      giftCoverAgeSelects.forEach((select) => {
        if (!select) return;
        select.addEventListener('change', () => {
          clearEditParams();
          select.dataset.userChosen = 'true';
          updatePackSummary();
        });
      });

      giftCoverChoices.forEach((choice) => choice.addEventListener('click', () => {
        clearEditParams();
        const row = choice.closest('[data-gift-cover-row]');
        const select = row?.querySelector('[data-gift-cover-select]');
        if (!select) return;
        select.value = choice.dataset.coverValue || select.value;
        const option = [...select.options].find((item) => item.value === select.value);
        if (option && choice.dataset.variantId) option.dataset.variantId = choice.dataset.variantId;
        syncGiftCoverSelect(select);
        syncGiftCoverMode();
        updatePackSummary();
      }));

      mobileAdd?.addEventListener('click', (event) => {
        /* V10.93 — le bouton mobile est aussi un submit HTML natif si JavaScript
           ne démarre pas. Quand le script est actif, on évite le double submit. */
        event.preventDefault();
        if (mobileAdd.disabled) return;
        if (typeof productForm?.requestSubmit === 'function') productForm.requestSubmit();
        else addButton?.click();
      });

      /* V141 — quand on arrive avec les paramètres d’édition du pack, on restaure
         le pack 1/2/3/4 au lieu de retomber systématiquement sur le pack 1. */
      try {
        const editParams = new URLSearchParams(window.location.search);
        const requestedPack = editParams.get('pack');
        if (Number(requestedPack) >= 3) setFamilyPackQuantity(Number(requestedPack), { select: false, announce: false });
        const requestedButton = packButtons.find((button) => button.dataset.packKey === requestedPack);
        const ageValueFromKey = (key) => ({
          '1-3': '1 à 3 ans',
          '3-8': '3 à 8 ans',
          '8-14': '8 à 14 ans'
        }[key] || '');
        if (requestedButton) {
          packKey = requestedButton.dataset.packKey;
          previousPackQuantity = Math.max(1, Number.parseInt(requestedButton.dataset.packQuantity || packKey || '1', 10) || 1);
          customizingSizes = false;
          packButtons.forEach((item) => {
            const selected = item === requestedButton;
            item.classList.toggle('is-selected', selected);
            item.setAttribute('aria-pressed', String(selected));
          });
          if (editParams.get('edit') === '1') {
            announceSelectionReady('Votre pack actuel a été rechargé. Vous pouvez changer d’offre ou ajuster les tailles : le panier remplacera automatiquement l’ancien pack.');
          }

          const requestedAges = String(editParams.get('ages') || '').split('|').map(ageValueFromKey).filter(Boolean);
          if (previousPackQuantity > 1) {
            syncBundleSizesToShared();
            requestedAges.slice(0, previousPackQuantity).forEach((value, index) => {
              if (bundleSizeSelects[index]) bundleSizeSelects[index].value = value;
            });
          } else if (requestedAges[0] && sizeSelect) {
            sizeSelect.value = requestedAges[0];
            sizeTitle = requestedAges[0];
          }

          [0, 1, 2].forEach((index) => {
            const motif = editParams.get(`gift${index + 1}`);
            const age = editParams.get(`giftAge${index + 1}`);
            if (motif && giftCoverSelects[index]) {
              giftCoverSelects[index].value = motif;
              syncGiftCoverSelect(giftCoverSelects[index]);
            }
            if (age && giftCoverAgeSelects[index]) {
              giftCoverAgeSelects[index].value = age;
              giftCoverAgeSelects[index].dataset.userChosen = 'true';
            }
          });
        }
      } catch (_) {}

      if (packButtons.length) updateSelection();

      if (mobileSticky && addButton) {
        let addButtonInView = false;
        const refreshSticky = () => {
          const rect = section.getBoundingClientRect();
          const sectionInView = rect.top < window.innerHeight && rect.bottom > 0;
          const mobileViewport = window.matchMedia('(max-width: 760px)').matches;
          mobileSticky.classList.toggle('is-visible', mobileViewport && sectionInView && !addButtonInView);
        };
        if ('IntersectionObserver' in window) {
          const stickyObserver = new IntersectionObserver(([entry]) => {
            addButtonInView = entry.isIntersecting;
            refreshSticky();
          }, { threshold: 0.35 });
          stickyObserver.observe(addButton);
        }
        window.addEventListener('scroll', refreshSticky, { passive: true });
        window.addEventListener('resize', refreshSticky);
        refreshSticky();
      }
    });


    /* V10.81 — Offre flash 24 h : cycle individuel persistant et renouvelé toutes les 24 h. */
    document.querySelectorAll('[data-bundle-urgency]').forEach((banner) => {
      const hoursNode = banner.querySelector('[data-urgency-hours]');
      const minutesNode = banner.querySelector('[data-urgency-minutes]');
      const secondsNode = banner.querySelector('[data-urgency-seconds]');
      const repeatHours = Math.max(1, Number.parseInt(banner.dataset.repeatHours || '24', 10) || 24);
      const cycleMs = repeatHours * 60 * 60 * 1000;
      const storageKey = banner.dataset.repeatKey || 'pioupiou-flash-24h-v1';

      const readEnd = () => {
        let end = 0;
        try { end = Number.parseInt(window.localStorage.getItem(storageKey) || '0', 10) || 0; } catch (_) {}
        if (!Number.isFinite(end) || end <= 0) end = Date.now() + cycleMs;
        while (end <= Date.now()) end += cycleMs;
        try { window.localStorage.setItem(storageKey, String(end)); } catch (_) {}
        return end;
      };

      let end = readEnd();
      const renderUrgency = () => {
        let remaining = end - Date.now();
        if (remaining <= 0) {
          do { end += cycleMs; } while (end <= Date.now());
          try { window.localStorage.setItem(storageKey, String(end)); } catch (_) {}
          remaining = end - Date.now();
        }
        const totalSeconds = Math.max(0, Math.floor(remaining / 1000));
        const h = Math.floor(totalSeconds / 3600);
        const m = Math.floor((totalSeconds % 3600) / 60);
        const sec = totalSeconds % 60;
        if (hoursNode) hoursNode.textContent = String(h).padStart(2, '0');
        if (minutesNode) minutesNode.textContent = String(m).padStart(2, '0');
        if (secondsNode) secondsNode.textContent = String(sec).padStart(2, '0');
      };

      renderUrgency();
      window.setInterval(renderUrgency, 1000);
    });


    /* V166 — Mini quiz Pioupiou : nombre d'enfants -> âge de chacun -> pack prérempli */
    (() => {
      const dialog = document.querySelector('[data-pack-quiz-dialog]');
      const offer = document.querySelector('#offre[data-product-section]');
      if (!dialog || !offer) return;

      const closeButtons = [...dialog.querySelectorAll('[data-pack-quiz-close]')];
      const openButtons = [...offer.querySelectorAll('[data-pack-quiz-open]')];
      const countButtons = [...dialog.querySelectorAll('[data-pack-quiz-count]')];
      const countStep = dialog.querySelector('[data-pack-quiz-step="count"]');
      const agesStep = dialog.querySelector('[data-pack-quiz-step="ages"]');
      const resultStep = dialog.querySelector('[data-pack-quiz-step="result"]');
      const ageRows = dialog.querySelector('[data-pack-quiz-age-rows]');
      const resultButton = dialog.querySelector('[data-pack-quiz-result]');
      const applyButton = dialog.querySelector('[data-pack-quiz-apply]');
      const backButton = dialog.querySelector('[data-pack-quiz-back]');
      const editButton = dialog.querySelector('[data-pack-quiz-edit]');
      const packNumber = dialog.querySelector('[data-pack-quiz-pack-number]');
      const packLabel = dialog.querySelector('[data-pack-quiz-pack-label]');
      const packCopy = dialog.querySelector('[data-pack-quiz-pack-copy]');
      const resultAges = dialog.querySelector('[data-pack-quiz-result-ages]');
      const giftNote = dialog.querySelector('[data-pack-quiz-gift-note]');
      const storageKey = 'pioupiou_pack_quiz_last_seen_v166';
      const sessionKey = 'pioupiou_pack_quiz_answers_v167';
      const ageOptions = [
        { key: '1-3', label: '1–3 ans', value: '1 à 3 ans' },
        { key: '3-8', label: '3–8 ans', value: '3 à 8 ans' },
        { key: '8-14', label: '8–14 ans', value: '8 à 14 ans' }
      ];
      let count = 0;
      let ages = [];
      let opened = false;
      let packChosenByUser = false;

      const setStep = (name) => {
        countStep.hidden = name !== 'count';
        agesStep.hidden = name !== 'ages';
        resultStep.hidden = name !== 'result';
        dialog.classList.toggle('is-success', name === 'result');
      };

      const rememberSeen = () => {
        try { window.localStorage.setItem(storageKey, String(Date.now())); } catch (_) {}
      };

      const saveSessionAnswers = () => {
        try {
          window.sessionStorage.setItem(sessionKey, JSON.stringify({ count, ages: ages.slice(0, count) }));
        } catch (_) {}
      };

      const restoreSessionAnswers = () => {
        try {
          const saved = JSON.parse(window.sessionStorage.getItem(sessionKey) || 'null');
          const savedCount = Number(saved?.count || 0);
          if (!Number.isInteger(savedCount) || savedCount < 1 || savedCount > 4 || !Array.isArray(saved?.ages)) return false;
          count = savedCount;
          ages = saved.ages.slice(0, count).map((value) => ageOptions.some((option) => option.value === value) ? value : '');
          countButtons.forEach((button) => button.setAttribute('aria-pressed', String(Number(button.dataset.packQuizCount) === count)));
          renderAgeRows();
          return true;
        } catch (_) {
          return false;
        }
      };

      const closeQuiz = () => {
        rememberSeen();
        if (typeof dialog.close === 'function' && dialog.open) dialog.close();
        else dialog.removeAttribute('open');
      };

      const renderAgeRows = () => {
        ageRows.replaceChildren();
        ages = Array.from({ length: count }, (_, index) => ages[index] || '');
        for (let index = 0; index < count; index += 1) {
          const row = document.createElement('div');
          row.className = 'pack-quiz__age-row';
          const label = document.createElement('p');
          label.className = 'pack-quiz__age-label';
          label.innerHTML = `<span>${index + 1}</span> Enfant ${index + 1}`;
          const options = document.createElement('div');
          options.className = 'pack-quiz__age-options';
          options.setAttribute('role', 'group');
          options.setAttribute('aria-label', `Âge de l'enfant ${index + 1}`);
          ageOptions.forEach((option) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.textContent = option.label;
            button.dataset.quizAgeIndex = String(index);
            button.dataset.quizAgeValue = option.value;
            button.setAttribute('aria-pressed', String(ages[index] === option.value));
            button.addEventListener('click', () => {
              ages[index] = option.value;
              [...options.querySelectorAll('button')].forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
              resultButton.disabled = ages.slice(0, count).some((value) => !value);
              saveSessionAnswers();
            });
            options.appendChild(button);
          });
          row.append(label, options);
          ageRows.appendChild(row);
        }
        resultButton.disabled = ages.slice(0, count).some((value) => !value);
      };

      const showResult = () => {
        if (!count || ages.slice(0, count).some((value) => !value)) return;
        if (packNumber) packNumber.textContent = String(count);
        if (packLabel) packLabel.textContent = count === 1 ? '1 Oreiller Pioupiou' : `Pack ${count}`;
        if (packCopy) packCopy.textContent = count === 1 ? 'Pour votre enfant' : `Pour ${count} enfants`;
        resultAges.replaceChildren();
        ages.slice(0, count).forEach((age, index) => {
          const row = document.createElement('div');
          row.className = 'pack-quiz__result-age';
          row.innerHTML = `<span>Enfant ${index + 1}</span><b>${age.replace(' à ', '–')}</b>`;
          resultAges.appendChild(row);
        });
        if (giftNote) {
          giftNote.hidden = count < 3;
          giftNote.textContent = count === 3
            ? 'Le Pack famille (3 oreillers) et les 3 tailles seront préremplis ; il ne restera qu’à choisir les 2 housses offertes.'
            : 'Le Pack famille (4 oreillers) et les 4 tailles seront préremplis ; il ne restera qu’à choisir les 3 housses offertes.';
        }
        if (applyButton) {
          applyButton.textContent = count === 1
            ? 'Continuer avec 1 oreiller →'
            : `Continuer avec le Pack ${count} →`;
        }
        saveSessionAnswers();
        setStep('result');
      };

      const applySelection = () => {
        let packButton = offer.querySelector(`[data-pack-button][data-pack-key="${count}"]`);
        if (count === 3 || count === 4) {
          const familyPack = offer.querySelector('[data-family-pack]');
          const currentFamilyQuantity = Number(familyPack?.dataset?.packQuantity || 3);
          if (familyPack && currentFamilyQuantity !== count) {
            const familyControl = familyPack.querySelector(count === 4 ? '[data-family-plus]' : '[data-family-minus]');
            if (familyControl) familyControl.click();
          } else if (familyPack) {
            familyPack.click();
          }
          packButton = familyPack || packButton;
        } else if (packButton) {
          packButton.click();
        }
        if (!packButton) return;

        if (count === 1) {
          const select = offer.querySelector('[data-size-select]');
          if (select && ages[0]) {
            select.value = ages[0];
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        } else {
          const selects = [...offer.querySelectorAll('[data-bundle-size-select]')].slice(0, count);
          selects.forEach((select, index) => {
            if (!ages[index]) return;
            select.value = ages[index];
            select.dispatchEvent(new Event('change', { bubbles: true }));
          });
        }

        rememberSeen();
        if (typeof dialog.close === 'function' && dialog.open) dialog.close();
        else dialog.removeAttribute('open');

        window.setTimeout(() => {
          const giftPicker = count >= 2 ? offer.querySelector('[data-gift-cover-picker]:not([hidden])') : null;
          const target = giftPicker || offer.querySelector('[data-pack-inline-editor]') || offer.querySelector('#packs-pioupiou') || offer;
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
          target.classList.add('pack-quiz-highlight');
          window.setTimeout(() => target.classList.remove('pack-quiz-highlight'), 1600);
        }, 80);
      };

      countButtons.forEach((button) => button.addEventListener('click', () => {
        const previousAges = ages.slice();
        count = Math.max(1, Math.min(4, Number(button.dataset.packQuizCount || 1)));
        countButtons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        ages = Array.from({ length: count }, (_, index) => previousAges[index] || '');
        saveSessionAnswers();
        renderAgeRows();
        setStep('ages');
      }));
      resultButton?.addEventListener('click', showResult);
      applyButton?.addEventListener('click', applySelection);
      backButton?.addEventListener('click', () => setStep('count'));
      editButton?.addEventListener('click', () => { renderAgeRows(); setStep('ages'); });
      closeButtons.forEach((button) => button.addEventListener('click', closeQuiz));
      if (dialog.tagName === 'DIALOG') {
        dialog.addEventListener('cancel', (event) => { event.preventDefault(); closeQuiz(); });
        dialog.addEventListener('click', (event) => { if (event.target === dialog) closeQuiz(); });
      }

      offer.querySelectorAll('[data-pack-button]').forEach((button) => {
        button.addEventListener('click', (event) => {
          if (event.isTrusted) packChosenByUser = true;
        }, { capture: true });
      });

      const mayOpen = () => {
        if (opened || dialog.open || packChosenByUser) return false;
        try {
          const last = Number(window.localStorage.getItem(storageKey) || 0);
          if (last && Date.now() - last < 7 * 24 * 60 * 60 * 1000) return false;
        } catch (_) {}
        return true;
      };
      const openQuiz = ({ manual = false } = {}) => {
        if (!manual && !mayOpen()) return;
        if (!manual) opened = true;
        const restored = restoreSessionAnswers();
        setStep(restored ? 'ages' : 'count');
        if (dialog.tagName === 'DIALOG') {
          if (typeof dialog.showModal === 'function' && !dialog.open) dialog.showModal();
          else dialog.setAttribute('open', '');
        } else {
          dialog.setAttribute('open', '');
          dialog.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      };

      /* V7 — quiz en popup douce, uniquement sur action volontaire du client. */
      if (dialog.tagName === 'DETAILS') {
        dialog.addEventListener('toggle', () => {
          if (!dialog.open) { rememberSeen(); return; }
          const restored = restoreSessionAnswers();
          setStep(restored ? 'ages' : 'count');
        });
      }
      openButtons.forEach((button) => button.addEventListener('click', () => openQuiz({ manual: true })));
    })();

    /* V142 — après nettoyage automatique d'un ancien panier, expliquer le retour
       vers les packs au lieu de laisser le client penser que sa sélection a disparu. */
    try {
      const pageParams = new URLSearchParams(window.location.search);
      if (pageParams.get('panier') === 'reset') {
        const resetFeedback = document.querySelector('[data-cart-feedback]');
        if (resetFeedback) resetFeedback.textContent = 'Ancien panier nettoyé pour éviter un mauvais total. Recomposez simplement votre pack.';
      }
    } catch (_) {}

    /* V10.62 — garde-fous du checkout direct.
       - le compteur panier est synchronisé après les mutations AJAX ;
       - l'éditeur Shopify ouvre le checkout hors de l'iframe ;
       - aucune instrumentation Meta manuelle n'est ajoutée ici. */
    const updateHeaderCartBadge = (state) => {
      const badge = document.querySelector('[data-cart-count-badge]') || document.querySelector('.cart-link b');
      if (!badge) return;
      const items = Array.isArray(state?.items) ? state.items : [];
      const largeLine = items.find((item) => item?.properties?.['_Pioupiou large order token'] && item?.properties?.['_Pioupiou total oreillers']);
      let count = Math.max(0, Number(state?.item_count || 0));
      if (largeLine) {
        const pillowTotal = Math.max(0, Number.parseInt(largeLine.properties['_Pioupiou total oreillers'] || '0', 10) || 0);
        const paidExtras = items.reduce((sum, item) => {
          if (item?.properties?.['_Pioupiou large order token']) return sum;
          if (item?.properties?.['_Pioupiou cadeau'] === '1' || item?.properties?.['_Pioupiou gift'] === '1') return sum;
          return sum + Math.max(0, Number(item?.quantity || 0));
        }, 0);
        count = pillowTotal + paidExtras;
      }
      badge.textContent = String(count);
      badge.hidden = count === 0;
      const link = badge.closest('.cart-link');
      if (link) link.setAttribute('aria-label', `Ouvrir le panier, ${count} article${count > 1 ? 's' : ''}`);
    };

    /* V10.92 — navigation checkout robuste sur desktop, mobile et navigateurs in-app.
       Le checkout Shopify est volontairement ouvert via sa route canonique /checkout :
       on évite ainsi qu'un préfixe de langue / marché transforme la destination en page
       inexistante. Dans l'éditeur Shopify uniquement, on conserve l'ouverture hors iframe. */
    const navigateToCheckout = (checkoutUrl = '/checkout') => {
      const requested = String(checkoutUrl || '/checkout').trim();
      const target = /(^|\/)checkout(?:[/?#]|$)/i.test(requested) ? '/checkout' : requested;
      const insideShopifyEditor = Boolean(window.Shopify?.designMode) || window.self !== window.top;
      if (insideShopifyEditor) {
        const previewCheckout = window.open(target, '_blank', 'noopener');
        if (previewCheckout) {
          try { previewCheckout.opener = null; } catch (_) {}
          return;
        }
        /* Popup bloquée : le fallback ci-dessous garde tout de même un chemin valide. */
      }
      try {
        window.location.assign(target);
      } catch (_) {
        /* Fallback pour certains WebViews / anciens navigateurs mobiles. */
        window.location.href = target;
      }
    };

    /* V10.93 — utilitaires fail-safe checkout. Les vérifications réseau qui ne sont
       pas indispensables ne doivent jamais emprisonner un client sur la page. */
    const withTimeout = (promise, ms, message = 'Délai dépassé') => new Promise((resolve, reject) => {
      let settled = false;
      const timer = window.setTimeout(() => {
        if (settled) return;
        settled = true;
        reject(new Error(message));
      }, ms);
      Promise.resolve(promise).then((value) => {
        if (settled) return;
        settled = true;
        window.clearTimeout(timer);
        resolve(value);
      }, (error) => {
        if (settled) return;
        settled = true;
        window.clearTimeout(timer);
        reject(error);
      });
    });
    /* V10.98 — timeout reseau qui annule aussi la requete cote navigateur.
       withTimeout reste utile pour les GET/Promesses, mais sur les mutations panier
       il pouvait expirer alors que le POST continuait en arriere-plan. Sur un reseau
       mobile lent cela pouvait provoquer une mutation tardive ou un doublon au retry. */
    const fetchWithTimeout = async (url, options = {}, ms = 6000, message = 'Délai réseau dépassé') => {
      if (typeof AbortController === 'undefined') {
        return withTimeout(fetch(url, options), ms, message);
      }
      const controller = new AbortController();
      const timer = window.setTimeout(() => controller.abort(), ms);
      try {
        return await fetch(url, { ...options, signal: controller.signal });
      } catch (error) {
        if (controller.signal.aborted || error?.name === 'AbortError') {
          const timeoutError = new Error(message);
          timeoutError.code = 'PIOUPIOU_TIMEOUT';
          throw timeoutError;
        }
        throw error;
      } finally {
        window.clearTimeout(timer);
      }
    };

    const setCheckoutBusy = (element, busy) => {
      if (!element) return;
      element.setAttribute('aria-busy', String(Boolean(busy)));
      element.classList.toggle('is-busy', Boolean(busy));
      if (element.tagName === 'BUTTON') element.disabled = Boolean(busy);
      else element.setAttribute('aria-disabled', String(Boolean(busy)));
    };

    /* V10.88 — personnalisation des housses offertes APRES le bundle.
       Le CTA checkout est prioritaire. Les housses payantes peuvent être composées
       en plusieurs motifs / tailles avant d'être ajoutées en une fois. */
    const runDirectCheckoutUpsell = ({ packQuantity, freeGiftCount, selectedAges, cartUrl, getCartState, checkoutUrl = '/checkout' }) => new Promise((resolve) => {
      const modal = document.querySelector('[data-direct-checkout-upsell]');
      if (!modal) { resolve({ added: false, navigating: false }); return; }

      const sheet = modal.querySelector('.direct-checkout-upsell__sheet');
      const title = modal.querySelector('[data-direct-upsell-title]');
      const eyebrow = modal.querySelector('[data-direct-gift-eyebrow]');
      const copy = modal.querySelector('[data-direct-upsell-copy]');
      const giftRows = [...modal.querySelectorAll('[data-direct-gift-row]')];
      const paidChoices = [...modal.querySelectorAll('[data-direct-upsell-choice]')];
      const paidSizeButtons = [...modal.querySelectorAll('[data-direct-upsell-size]')];
      const qtyOutput = modal.querySelector('[data-direct-upsell-qty]');
      const qtyMinus = modal.querySelector('[data-direct-upsell-minus]');
      const qtyPlus = modal.querySelector('[data-direct-upsell-plus]');
      const addButton = modal.querySelector('[data-direct-upsell-add]');
      const paidSelection = modal.querySelector('[data-direct-paid-selection]');
      const paidLines = modal.querySelector('[data-direct-paid-lines]');
      const paidTotal = modal.querySelector('[data-direct-paid-total]');
      const checkoutButtons = [...modal.querySelectorAll('[data-direct-upsell-skip]')];
      const dismissButtons = [...modal.querySelectorAll('[data-direct-upsell-dismiss]')];
      const status = modal.querySelector('[data-direct-upsell-status]');
      const paidDetails = modal.querySelector('[data-direct-paid-extra]');
      const currency = window.Shopify?.currency?.active || 'EUR';
      const money = new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', { style: 'currency', currency });
      const giftCount = Math.min(3, Number.isFinite(Number(freeGiftCount)) ? Math.max(0, Number(freeGiftCount)) : Math.max(0, Number(packQuantity || 1) - 1));
      const selectedAgeList = Array.isArray(selectedAges) ? selectedAges.filter(Boolean) : [];

      const normalizeSize = (value) => {
        const numbers = String(value || '').replace(/[–—−]/g, '-').match(/\d+/g) || [];
        const key = numbers.length >= 2 ? `${numbers[0]}-${numbers[1]}` : '';
        if (key === '1-3') return '1–3 ans';
        if (key === '8-14') return '8–14 ans';
        return '3–8 ans';
      };
      const simpleBundleAge = (value) => normalizeSize(value).replace('–', '-').replace(' ans', '');

      const freeSelections = giftRows.map((row, index) => ({
        motif: index % 2 === 0 ? 'Espace bleu' : 'Mer rose',
        variantId: 0,
        size: normalizeSize(selectedAgeList[index] || selectedAgeList[0] || '3 à 8 ans')
      }));
      let paidVariantId = 0;
      let paidTitle = '';
      let paidUnitPrice = 0;
      let paidSize = normalizeSize(selectedAgeList[0] || '3 à 8 ans');
      let quantity = 1;
      let paidSelections = [];
      let busy = false;

      giftRows.forEach((row, index) => {
        row.hidden = index >= giftCount;
        const count = row.querySelector('[data-direct-gift-of]');
        if (count) count.textContent = `sur ${giftCount}`;
        const choices = [...row.querySelectorAll('[data-direct-gift-choice]')];
        const defaultChoice = choices[index % Math.max(1, choices.length)] || choices[0];
        if (defaultChoice) {
          freeSelections[index].motif = String(defaultChoice.dataset.title || 'Espace bleu');
          freeSelections[index].variantId = Number(defaultChoice.dataset.variantId || 0);
        }
        choices.forEach((choice) => {
          const active = choice === defaultChoice;
          choice.setAttribute('aria-pressed', String(active));
          choice.onclick = () => {
            if (busy) return;
            choices.forEach((item) => item.setAttribute('aria-pressed', String(item === choice)));
            freeSelections[index].motif = String(choice.dataset.title || 'Espace bleu');
            freeSelections[index].variantId = Number(choice.dataset.variantId || 0);
            if (status) status.textContent = '';
          };
        });
        const sizes = [...row.querySelectorAll('[data-direct-gift-size]')];
        sizes.forEach((button) => {
          const active = String(button.dataset.directGiftSize || '') === freeSelections[index].size;
          button.setAttribute('aria-pressed', String(active));
          button.onclick = () => {
            if (busy) return;
            freeSelections[index].size = String(button.dataset.directGiftSize || '3–8 ans');
            sizes.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
            if (status) status.textContent = '';
          };
        });
      });

      if (giftCount > 0) {
        if (eyebrow) eyebrow.textContent = 'INCLUS DANS VOTRE PACK';
        if (title) title.textContent = giftCount > 1 ? 'Vos housses offertes 🎁' : 'Votre housse offerte 🎁';
        if (copy) copy.textContent = giftCount > 1 ? 'Choisissez simplement le motif et la taille de chaque housse.' : 'Choisissez simplement son motif et sa taille.';
      } else {
        if (eyebrow) eyebrow.textContent = 'OPTIONNEL';
        if (title) title.textContent = 'Ajouter une housse ?';
        if (copy) copy.textContent = 'Votre pack est prêt. Ajoutez une housse ou passez au paiement.';
        if (paidDetails) paidDetails.open = true;
      }

      const renderPaidSummary = () => {
        if (!paidSelection || !paidLines || !paidTotal) return;
        paidSelection.hidden = paidSelections.length === 0;
        paidLines.innerHTML = paidSelections.map((item, index) => `
          <div class="direct-paid-line">
            <span><b>${item.title}</b><small>${item.size} · ×${item.quantity}</small></span>
            <strong>${money.format((item.unitPrice * item.quantity) / 100)}</strong>
            <button type="button" data-remove-paid="${index}" aria-label="Supprimer">×</button>
          </div>`).join('');
        paidTotal.textContent = money.format(paidSelections.reduce((sum, item) => sum + item.unitPrice * item.quantity, 0) / 100);
        [...paidLines.querySelectorAll('[data-remove-paid]')].forEach((button) => {
          button.onclick = () => {
            if (busy) return;
            paidSelections.splice(Number(button.dataset.removePaid || 0), 1);
            renderPaidSummary();
          };
        });
      };

      const render = () => {
        quantity = Math.max(1, Math.min(6, quantity));
        if (qtyOutput) qtyOutput.textContent = String(quantity);
        if (qtyMinus) qtyMinus.disabled = busy || quantity <= 1;
        if (qtyPlus) qtyPlus.disabled = busy || quantity >= 6;
        paidSizeButtons.forEach((button) => {
          button.setAttribute('aria-pressed', String(String(button.dataset.directUpsellSize || '') === paidSize));
          button.disabled = busy;
        });
        paidChoices.forEach((choice) => { choice.disabled = busy; });
        checkoutButtons.forEach((button) => { button.disabled = busy; });
        dismissButtons.forEach((button) => { button.disabled = busy; });
        giftRows.forEach((row) => row.querySelectorAll('button').forEach((button) => { button.disabled = busy; }));
        if (addButton) {
          addButton.disabled = busy || !paidVariantId || !paidSize;
          addButton.textContent = busy ? 'Préparation…' : (!paidVariantId ? 'Choisissez un motif' : `Ajouter cette housse · ${money.format((paidUnitPrice * quantity) / 100)}`);
        }
      };

      const cleanup = () => {
        document.removeEventListener('keydown', onKeydown);
        modal.hidden = true;
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('direct-upsell-open');
      };
      const finish = (result) => { cleanup(); resolve(result); };

      paidChoices.forEach((choice) => {
        choice.setAttribute('aria-pressed', 'false');
        choice.onclick = () => {
          if (busy) return;
          paidVariantId = Math.max(0, Number(choice.dataset.variantId || 0));
          paidTitle = String(choice.dataset.title || 'Housse');
          paidUnitPrice = Math.max(0, Number(choice.dataset.unitPriceCents || document.body?.dataset?.pioupiouCoverUpsellPrice || 999));
          paidChoices.forEach((item) => item.setAttribute('aria-pressed', String(item === choice)));
          if (status) status.textContent = '';
          render();
        };
      });
      paidSizeButtons.forEach((button) => {
        button.onclick = () => {
          if (busy) return;
          paidSize = String(button.dataset.directUpsellSize || '3–8 ans');
          if (status) status.textContent = '';
          render();
        };
      });
      if (qtyMinus) qtyMinus.onclick = () => { if (!busy) { quantity -= 1; render(); } };
      if (qtyPlus) qtyPlus.onclick = () => { if (!busy) { quantity += 1; render(); } };
      if (addButton) addButton.onclick = () => {
        if (busy || !paidVariantId || !paidSize) return;
        paidSelections.push({ variantId: paidVariantId, title: paidTitle, unitPrice: paidUnitPrice, size: paidSize, quantity });
        quantity = 1;
        paidVariantId = 0;
        paidTitle = '';
        paidUnitPrice = 0;
        paidChoices.forEach((item) => item.setAttribute('aria-pressed', 'false'));
        renderPaidSummary();
        render();
      };

      const persistFreeGifts = async () => {
        if (giftCount <= 0) return null;
        const state = await getCartState();
        const items = Array.isArray(state?.items) ? state.items : [];
        const parent = items.find((item) => String(item?.properties?.['_Pioupiou bundle'] || '') === '1')
          || items.find((item) => Number(item?.properties?.['_Pioupiou pack'] || 0) === Number(packQuantity || 0))
          || items[0];
        if (!parent?.key) throw new Error('Le pack est prêt, mais sa personnalisation n’a pas pu être enregistrée. Réessayez.');
        const properties = { ...(parent.properties || {}) };
        for (let i = 0; i < giftCount; i += 1) {
          const gift = freeSelections[i];
          if (!gift?.motif || !gift?.size) continue;
          const index = i + 1;
          const label = `Housse d'oreiller enfant — ${gift.motif} — ${gift.size}`;
          properties[`Housse offerte ${index}`] = label;
          properties[`Taille housse offerte ${index}`] = gift.size;
          properties[`Housse ${index}`] = gift.motif;
          properties[`Taille housse ${index}`] = simpleBundleAge(gift.size);
          properties[`_Pioupiou housse ${index}`] = label;
          properties[`_Pioupiou housse age ${index}`] = gift.size;
          if (gift.variantId) properties[`_Housse offerte variante ${index}`] = String(gift.variantId);
        }
        const response = await fetchWithTimeout(cartUrl('cart/change.js'), {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, credentials: 'same-origin',
          body: JSON.stringify({ id: parent.key, quantity: Number(parent.quantity || 1), properties })
        }, 3200, 'Synchronisation des housses offerte trop lente');
        if (!response.ok) throw new Error('Impossible d’enregistrer le choix des housses offertes. Réessayez.');
        return response.json().catch(() => null);
      };

      const addPaidSelections = async () => {
        if (!paidSelections.length) return null;
        const items = paidSelections.map((item) => ({
          id: Number(item.variantId), quantity: Number(item.quantity), properties: {
            'Taille de la housse': item.size,
            '_Pioupiou upsell': 'Housse payante'
          }
        }));
        const response = await fetchWithTimeout(cartUrl('cart/add.js'), {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, credentials: 'same-origin',
          body: JSON.stringify({ items })
        }, 4200, 'Ajout des housses supplémentaires trop lent');
        if (!response.ok) {
          const apiError = await response.json().catch(() => null);
          throw new Error(String(apiError?.description || apiError?.message || 'Impossible d’ajouter les housses supplémentaires.'));
        }
        return response.json().catch(() => null);
      };

      const checkout = async () => {
        if (busy) return;
        busy = true;
        if (status) status.textContent = 'Préparation de votre commande…';
        render();
        try {
          const giftState = await withTimeout(persistFreeGifts(), 2600, 'Synchronisation des housses trop lente');
          const paidState = await withTimeout(addPaidSelections(), 3600, 'Ajout de la housse trop lent');
          const state = paidState || giftState;
          if (state) updateHeaderCartBadge(state);
          cleanup();
          resolve({ added: paidSelections.length > 0, navigating: true, cart: state || null });
          navigateToCheckout(checkoutUrl || '/checkout');
        } catch (error) {
          /* V10.93 — une option de housse ne doit jamais bloquer la commande.
             Le pack principal est déjà dans Shopify : on avertit puis on continue. */
          if (status) status.textContent = 'Une option n’a pas pu être enregistrée. Ouverture du paiement…';
          cleanup();
          resolve({ added: false, navigating: true, optionError: true });
          window.setTimeout(() => navigateToCheckout(checkoutUrl || '/checkout'), 180);
        }
      };

      checkoutButtons.forEach((button) => { button.onclick = (event) => { event.preventDefault(); event.stopPropagation(); checkout(); }; });
      dismissButtons.forEach((button) => { button.onclick = (event) => { event.preventDefault(); event.stopPropagation(); if (!busy) finish({ added: false, dismissed: true, navigating: false }); }; });
      function onKeydown(event) { if (event.key === 'Escape' && !busy) { event.preventDefault(); finish({ added: false, dismissed: true, navigating: false }); } }
      document.addEventListener('keydown', onKeydown);

      if (status) status.textContent = '';
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('direct-upsell-open');
      renderPaidSummary();
      render();
      window.requestAnimationFrame(() => sheet?.focus({ preventScroll: true }));
    });
    document.querySelectorAll('[data-ajax-product-form]').forEach((form) => {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const section = form.closest('[data-product-section]');
        const button = form.querySelector('[data-add-to-cart]');
        const feedback = form.querySelector('[data-cart-feedback]');
        const label = form.querySelector('[data-add-text]');
        const mobileButton = section?.querySelector('[data-mobile-add]');
        const initialLabel = label?.textContent;
        const initialMobileLabel = mobileButton?.textContent;
        if (button?.disabled) return;

        try {
          button.disabled = true;
          if (mobileButton) {
            mobileButton.disabled = true;
            mobileButton.textContent = 'Préparation…';
          }
          if (label) label.textContent = 'Préparation…';
          if (feedback) feedback.textContent = '';

          const selectedPack = section?.querySelector('[data-pack-button].is-selected');
          const packQuantity = Math.max(1, Number.parseInt(selectedPack?.dataset.packQuantity || '1', 10) || 1);
          const buildPackPlan = (requestedQuantity) => {
            const quantity = Math.max(1, Math.floor(Number(requestedQuantity || 1)));
            return [quantity <= 4 ? quantity : 4];
          };
          const packPlan = buildPackPlan(packQuantity);
          const configuredGiftCount = Number.parseInt(selectedPack?.dataset.packGifts || '', 10);
          const packGiftCount = Number.isFinite(configuredGiftCount)
            ? Math.max(0, configuredGiftCount)
            : (packQuantity <= 4 ? Math.max(0, packQuantity - 1) : 3);
          const packConfig = {
            image: packQuantity <= 4 ? `bundle-${packQuantity}.jpg` : 'bundle-5plus.jpg',
            gifts: packGiftCount,
            plan: packPlan
          };
          const variantId = form.querySelector('[data-variant-input]')?.value;
          const normalizeAge = (value) => {
            const numbers = String(value || '').replace(/[–—−]/g, '-').match(/\d+/g) || [];
            if (numbers.length < 2) return '';
            const key = `${numbers[0]}-${numbers[1]}`;
            return ['1-3', '3-8', '8-14'].includes(key) ? key : '';
          };

          let products = {};
          let directVariantMap = {};
          let giftCoverProduct = null;
          try {
            const productScript = section?.querySelector('[data-bundle-products]');
            products = productScript ? JSON.parse(productScript.textContent) : {};
          } catch (_) { products = {}; }
          try {
            const mapScript = section?.querySelector('[data-direct-variant-map]');
            directVariantMap = mapScript ? JSON.parse(mapScript.textContent) : {};
          } catch (_) { directVariantMap = {}; }
          try {
            const giftScript = section?.querySelector('[data-gift-cover-product]');
            giftCoverProduct = giftScript ? JSON.parse(giftScript.textContent) : null;
          } catch (_) { giftCoverProduct = null; }
          directVariantMap = {
            '1-3': Number(directVariantMap['1-3'] || 58458933035272),
            '3-8': Number(directVariantMap['3-8'] || 58458933068040),
            '8-14': Number(directVariantMap['8-14'] || 58458933100808)
          };

          const sourceProduct = products['1'] || products[selectedPack?.dataset.packKey || '1'] || {};
          const variants = sourceProduct?.variants || [];
          const normalizedVariant = (value) => String(value || '')
            .trim()
            .toLowerCase()
            .replace(/[–—−]/g, '-')
            .replace(/\s+/g, ' ');
          const findVariantForCheckout = (requestedTitle) => {
            const requestedAge = normalizeAge(requestedTitle);
            const directId = requestedAge && directVariantMap[requestedAge] ? Number(directVariantMap[requestedAge]) : 0;
            if (directId) {
              const knownVariant = variants.find((item) => Number(item.id) === directId);
              if (!knownVariant || knownVariant.available !== false) return knownVariant || { id: directId, available: true, title: requestedTitle };
            }
            return variants.find((item) => item.available && requestedAge && normalizeAge(item.title) === requestedAge)
              || variants.find((item) => item.available && normalizedVariant(item.title) === normalizedVariant(requestedTitle))
              || null;
          };

          const cartItems = [];
          const selectedAges = [];
          const selectedComponentVariantIds = [];
          if (packQuantity > 1) {
            const detailedPicker = section?.querySelector('[data-bundle-size-picker]');
            const detailed = Boolean(detailedPicker && !detailedPicker.hidden);
            const allSizeSelects = [...(section?.querySelectorAll('[data-bundle-size-select]') || [])];
            const sharedAge = section?.querySelector('[data-size-select]')?.value || '3 à 8 ans';
            const ageValues = detailed
              ? allSizeSelects.slice(0, packQuantity).map((select) => select.value)
              : Array.from({ length: packQuantity }, () => sharedAge);
            if (ageValues.length !== packQuantity) throw new Error('Veuillez choisir la taille de chaque oreiller.');
            const counts = new Map();
            ageValues.forEach((age) => {
              const variant = findVariantForCheckout(age);
              const id = Number(variant?.id || 0);
              if (!id) throw new Error(`La taille ${age} n’est pas disponible actuellement.`);
              selectedAges.push(age);
              selectedComponentVariantIds.push(id);
              counts.set(id, (counts.get(id) || 0) + 1);
            });
            counts.forEach((quantity, id) => cartItems.push({ id, quantity }));
          } else {
            const requestedSingleSize = section?.querySelector('[data-size-select]')?.value || '3 à 8 ans';
            const selectedVariant = variants.find((item) => item.available && String(item.id) === String(variantId)) || findVariantForCheckout(requestedSingleSize);
            if (!selectedVariant?.id) throw new Error('Veuillez choisir une taille disponible avant de continuer.');
            selectedAges.push(requestedSingleSize);
            selectedComponentVariantIds.push(Number(selectedVariant.id));
            cartItems.push({ id: Number(selectedVariant.id), quantity: 1 });
          }

          if (!cartItems.length) throw new Error('Aucun oreiller n’a pu être préparé pour le panier.');

          const sameAgeForAll = packQuantity > 1 && selectedAges.length === packQuantity && selectedAges.every((age) => age === selectedAges[0]);
          const simpleBundlesAgeValue = (age) => {
            const normalized = normalizeAge(age);
            if (normalized === '1-3') return '1-3 ans';
            if (normalized === '3-8') return '3-8 ans';
            if (normalized === '8-14') return '8-14 ans';
            return String(age || '').trim();
          };
          const properties = {
            'Pack Pioupiou': `${packQuantity} oreiller${packQuantity > 1 ? 's' : ''}`,
            'Tailles choisies': sameAgeForAll
              ? `Même taille pour tout le pack : ${selectedAges[0]} × ${packQuantity}`
              : selectedAges.map((age, index) => `Oreiller ${index + 1}: ${age}`).join(' | ')
          };

          /* V153 - contrat Simple Bundles Infinite Options.
             Les options Infinite Options sont transmises comme line item properties.
             Les noms sont volontairement stables : Oreiller 1..4, Housse 1..2,
             Taille housse 1..2. Les valeurs d'âge suivent les titres des variantes
             Shopify (1-3 ans / 3-8 ans / 8-14 ans) afin que Simple Bundles puisse
             associer chaque choix à la bonne variante enfant. */
          selectedAges.forEach((age, index) => {
            properties[`Oreiller ${index + 1}`] = simpleBundlesAgeValue(age);
          });

          const coverSelects = [...(section?.querySelectorAll('[data-gift-cover-select]') || [])];
          const coverAgeSelects = [...(section?.querySelectorAll('[data-gift-cover-age-select]') || [])];
          const visibleGiftChoices = [];
          if (packConfig.gifts > 0) {
            const editableGiftCount = Math.min(packConfig.gifts, coverSelects.length, coverAgeSelects.length);
            coverSelects.slice(0, editableGiftCount).forEach((select, index) => {
              const title = String(select.value || '').trim();
              const variant = select.dataset.selectedVariantId || select.options?.[select.selectedIndex]?.dataset?.variantId || '';
              const age = String(coverAgeSelects[index]?.value || selectedAges[index] || selectedAges[0] || '3 à 8 ans').trim();
              if (!title || !normalizeAge(age)) return;
              visibleGiftChoices.push({ title, variant: String(variant || ''), age });
            });

            /* V10.88 : le bundle reste léger. Les choix de housses se font dans la popup.
               On initialise toutefois des valeurs valides pour Simple Bundles au moment
               du cart/add ; la popup les remplace ensuite avec le choix final du client. */
            const giftVariants = Array.isArray(giftCoverProduct?.variants) ? giftCoverProduct.variants : [];
            const normalizeGiftName = (value) => String(value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
            const variantForMotif = (motif) => {
              const wanted = normalizeGiftName(motif);
              return giftVariants.find((variant) => variant.available !== false && normalizeGiftName(variant.title).includes(wanted))?.id || '';
            };
            for (let index = 0; index < packConfig.gifts; index += 1) {
              const existing = visibleGiftChoices[index];
              const title = String(existing?.title || (index % 2 === 0 ? 'Espace bleu' : 'Mer rose'));
              const age = String(existing?.age || selectedAges[index] || selectedAges[0] || '3 à 8 ans');
              const variant = String(existing?.variant || variantForMotif(title) || '');
              if (!visibleGiftChoices[index]) visibleGiftChoices[index] = { title, variant, age };
              if (packQuantity <= 4) {
                properties[`Housse offerte ${index + 1}`] = `Housse d'oreiller enfant — ${title} — ${age}`;
                properties[`Taille housse offerte ${index + 1}`] = age;
                properties[`Housse ${index + 1}`] = title;
                properties[`Taille housse ${index + 1}`] = simpleBundlesAgeValue(age);
                if (variant) properties[`_Housse offerte variante ${index + 1}`] = variant;
              }
            }
          }

          /* V10.58 — skip-cart sécurisé : un clic Commander = un seul pack actif.
             Le pack est réellement ajouté au panier Shopify puis contrôlé via /cart.js
             (structure + prix) avant d'ouvrir directement le checkout. La page /cart
             reste disponible via l'icône panier, mais n'est plus une étape obligatoire. */
          const root = window.Shopify?.routes?.root || '/';
          const cartUrl = (path) => `${root}${path}`.replace(/\/{2,}/g, '/');
          const jsonHeaders = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
          /* V10.18 — prix lus depuis les reglages du theme (source unique).
             Les valeurs ci-dessous ne servent que de secours si l'attribut manque. */
          const themePrices = document.body?.dataset || {};
          const readPackPrice = (key, fallback) => {
            const raw = Number(themePrices[`pioupiouPrice${key}`]);
            return Number.isFinite(raw) && raw > 0 ? raw : fallback;
          };
          const expectedPackPrices = {
            1: readPackPrice(1, 5999),
            2: readPackPrice(2, 8999),
            3: readPackPrice(3, 11999),
            4: readPackPrice(4, 14999)
          };
          const packParentVariants = {
            1: Number(themePrices.pioupiouParentVariant1 || 58499777036552),
            2: Number(themePrices.pioupiouParentVariant2 || 58499777134856),
            3: Number(themePrices.pioupiouParentVariant3 || 58499777265928),
            4: Number(themePrices.pioupiouParentVariant4 || 58499777331464)
          };
          const extraUnitPrice = Math.max(0, Number(document.body?.getAttribute('data-pioupiou-extra-price') || 3750));
          const expectedPackPrice = packQuantity <= 4
            ? Number(expectedPackPrices[packQuantity] || 0)
            : Number(expectedPackPrices[4] || 0) + ((packQuantity - 4) * extraUnitPrice);
          const parentVariantId = packQuantity <= 4 ? Number(packParentVariants[packQuantity] || 0) : 0;
          if (packQuantity <= 4 && !parentVariantId) throw new Error('Le produit parent de ce pack n est pas configure.');
          let bundleToken = `pioupiou-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;

          const getCartState = async () => {
            const response = await withTimeout(fetch(cartUrl('cart.js'), {
              headers: { 'Accept': 'application/json' },
              credentials: 'same-origin',
              cache: 'no-store'
            }), 4500, 'Vérification du panier trop lente');
            if (!response.ok) throw new Error('Le panier n’a pas pu être vérifié.');
            return response.json();
          };
          const getCartStateWithRetry = async (attempts = 3) => {
            let lastError = null;
            for (let attempt = 0; attempt < attempts; attempt += 1) {
              try { return await getCartState(); } catch (error) { lastError = error; }
              if (attempt < attempts - 1) await new Promise((resolve) => window.setTimeout(resolve, 220 + (attempt * 180)));
            }
            throw lastError || new Error('Le panier n’a pas pu être vérifié.');
          };

          const emptyCartCompletely = async () => {
            const clearResponse = await fetch(cartUrl('cart/clear.js'), {
              method: 'POST',
              headers: jsonHeaders,
              credentials: 'same-origin'
            });
            if (!clearResponse.ok) throw new Error('Impossible de préparer votre panier. Réessayez dans quelques secondes.');

            let state = await getCartState();
            if (Number(state?.item_count || 0) === 0) return;

            /* Filet de sécurité pour les anciens paniers / aperçus Shopify qui peuvent
               garder des lignes : on force chaque ligne existante à zéro. */
            const updates = {};
            (state.items || []).forEach((item) => {
              if (item?.key) updates[item.key] = 0;
            });
            if (Object.keys(updates).length) {
              const updateResponse = await fetch(cartUrl('cart/update.js'), {
                method: 'POST',
                headers: jsonHeaders,
                credentials: 'same-origin',
                body: JSON.stringify({ updates })
              });
              if (!updateResponse.ok) throw new Error('Impossible de remplacer l’ancienne sélection.');
            }

            state = await getCartState();
            if (Number(state?.item_count || 0) !== 0) {
              throw new Error('Votre ancien panier n’a pas pu être remis à zéro. Rechargez la page puis réessayez.');
            }
          };

          /* V10.74 — Pack famille sans plafond.
             À partir de 5 oreillers : 1 vrai Pack 4 Simple Bundles à 149,99 €
             + N vrais variants Shopify « Oreiller supplémentaire » à 37,50 €.
             Les 3 housses du Pack 4 restent les seules housses offertes : aucun cadeau
             supplémentaire n'est créé quand la quantité augmente. */
          if (packQuantity > 4) {
            const pack4Parent = Number(packParentVariants[4] || 0);
            const pack4Price = Number(expectedPackPrices[4] || 0);
            if (!pack4Parent || !pack4Price) throw new Error('Le Pack 4 n’est pas configuré dans Shopify.');

            const extraVariantMap = {
              '1-3': Number(document.body?.getAttribute('data-pioupiou-extra-variant-1-3') || 58599890288904),
              '3-8': Number(document.body?.getAttribute('data-pioupiou-extra-variant-3-8') || 58599890321672),
              '8-14': Number(document.body?.getAttribute('data-pioupiou-extra-variant-8-14') || 58599890354440)
            };
            const orderToken = `pioupiou-large-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
            const baseAges = selectedAges.slice(0, 4);
            const baseComponentVariantIds = selectedComponentVariantIds.slice(0, 4);
            if (baseAges.length !== 4) throw new Error('Veuillez choisir la taille des 4 premiers oreillers.');
            const sameBaseAge = baseAges.every((age) => age === baseAges[0]);

            const pack4Properties = {
              'Pack Pioupiou': `Pack famille · ${packQuantity} oreillers`,
              'Tailles choisies': selectedAges.map((age, index) => `Oreiller ${index + 1}: ${age}`).join(' | '),
              '_Pioupiou bundle': '1',
              '_Pioupiou pack': '4',
              '_Pioupiou oreillers': '4',
              '_Pioupiou total oreillers': String(packQuantity),
              '_Pioupiou pack visuel': 'bundle-5plus.jpg',
              '_Pioupiou configuration': selectedAges.map((age) => normalizeAge(age)).join('|'),
              '_Pioupiou bundle token': `${orderToken}-pack4`,
              '_Pioupiou large order token': orderToken,
              '_Pioupiou prix pack': String(pack4Price),
              '_Pioupiou parent variant': String(pack4Parent),
              '_Pioupiou component variants': baseComponentVariantIds.join('|'),
              '_Pioupiou extra units': String(packQuantity - 4)
            };
            baseAges.forEach((age, index) => {
              pack4Properties[`Oreiller ${index + 1}`] = simpleBundlesAgeValue(age);
            });
            if (sameBaseAge) pack4Properties['Tailles du Pack 4'] = `${baseAges[0]} × 4`;

            const giftVariants = giftCoverProduct?.variants || [];
            const normalizeGift = (value) => String(value || '').trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[–—−]/g, '-').replace(/\s+/g, ' ');
            const fallbackGiftChoices = [
              visibleGiftChoices[0] || { title: 'Espace bleu', age: baseAges[0] || '3 à 8 ans', variant: '' },
              visibleGiftChoices[1] || { title: 'Mer rose', age: baseAges[1] || baseAges[0] || '3 à 8 ans', variant: '' },
              visibleGiftChoices[2] || visibleGiftChoices[0] || { title: 'Espace bleu', age: baseAges[2] || baseAges[0] || '3 à 8 ans', variant: '' }
            ];
            const giftVariantId = (choice) => {
              if (choice?.variant) return String(choice.variant);
              const requested = normalizeGift(choice?.title);
              const match = giftVariants.find((variant) => variant.available !== false && (normalizeGift(variant.title).includes(requested) || requested.includes(normalizeGift(variant.title))));
              return match?.id ? String(match.id) : '';
            };
            for (let giftIndex = 0; giftIndex < 3; giftIndex += 1) {
              const choice = fallbackGiftChoices[giftIndex] || fallbackGiftChoices[0];
              const age = String(choice?.age || baseAges[Math.min(giftIndex, baseAges.length - 1)] || baseAges[0] || '3 à 8 ans');
              const title = String(choice?.title || (giftIndex % 2 === 0 ? 'Espace bleu' : 'Mer rose'));
              const variant = giftVariantId({ ...choice, title });
              pack4Properties[`Housse offerte ${giftIndex + 1}`] = `Housse d'oreiller enfant — ${title} — ${age}`;
              pack4Properties[`Taille housse offerte ${giftIndex + 1}`] = age;
              pack4Properties[`Housse ${giftIndex + 1}`] = title;
              pack4Properties[`Taille housse ${giftIndex + 1}`] = simpleBundlesAgeValue(age);
              pack4Properties[`_Pioupiou housse ${giftIndex + 1}`] = `Housse d'oreiller enfant — ${title} — ${age}`;
              pack4Properties[`_Pioupiou housse age ${giftIndex + 1}`] = age;
              if (variant) pack4Properties[`_Housse offerte variante ${giftIndex + 1}`] = variant;
            }

            const itemsToAdd = [{ id: pack4Parent, quantity: 1, properties: pack4Properties }];
            const extraGroups = new Map();
            selectedAges.slice(4).forEach((age) => {
              const ageKey = normalizeAge(age);
              const extraVariantId = Number(extraVariantMap[ageKey] || 0);
              if (!extraVariantId) throw new Error(`L’oreiller supplémentaire ${age} n’est pas configuré.`);
              const current = extraGroups.get(extraVariantId) || { quantity: 0, age };
              current.quantity += 1;
              extraGroups.set(extraVariantId, current);
            });
            extraGroups.forEach((group, extraVariantId) => {
              itemsToAdd.push({
                id: Number(extraVariantId),
                quantity: group.quantity,
                properties: {
                  '_Pioupiou extra': '1',
                  '_Pioupiou extra age': String(group.age || ''),
                  '_Pioupiou extra unit price': String(extraUnitPrice),
                  '_Pioupiou total oreillers': String(packQuantity),
                  '_Pioupiou large order token': orderToken,
                  '_Pioupiou pack visuel': 'bundle-5plus.jpg'
                }
              });
            });

            /* V10.98 — le POST est annulable et, si le timeout arrive après réception
               côté Shopify, on réconcilie le panier via le token avant d'autoriser un retry.
               Cela évite deux Packs famille sur les WebViews/4G lentes. */
            let addResponse = null;
            let recoveredLargeState = null;
            let addTimeoutError = null;
            try {
              addResponse = await fetchWithTimeout(cartUrl('cart/add.js'), {
                method: 'POST',
                headers: jsonHeaders,
                credentials: 'same-origin',
                body: JSON.stringify({ items: itemsToAdd })
              }, 7000, 'Ajout du Pack famille trop lent. Réessayez.');
            } catch (error) {
              if (error?.code !== 'PIOUPIOU_TIMEOUT') throw error;
              addTimeoutError = error;
              for (let recoveryAttempt = 0; recoveryAttempt < 4; recoveryAttempt += 1) {
                const candidate = await getCartState().catch(() => null);
                const tokenLines = (candidate?.items || []).filter((item) => String(item?.properties?.['_Pioupiou large order token'] || '') === orderToken);
                const parentRecovered = tokenLines.some((item) => String(item?.properties?.['_Pioupiou bundle'] || '') === '1');
                const extraRecovered = tokenLines.reduce((sum, item) => String(item?.properties?.['_Pioupiou extra'] || '') === '1' ? sum + Math.max(0, Number(item?.quantity || 0)) : sum, 0);
                if (parentRecovered && extraRecovered === (packQuantity - 4)) {
                  recoveredLargeState = candidate;
                  break;
                }
                if (recoveryAttempt < 3) await new Promise((resolve) => window.setTimeout(resolve, 350));
              }
              if (!recoveredLargeState) throw addTimeoutError;
            }
            if (addResponse && !addResponse.ok) {
              const apiError = await addResponse.json().catch(() => null);
              throw new Error(String(apiError?.description || apiError?.message || 'Impossible de préparer le Pack famille.'));
            }

            let cartState = recoveredLargeState;
            let largePriceOk = false;
            for (let attempt = 0; attempt < 7; attempt += 1) {
              try {
                if (!cartState || attempt > 0) cartState = await getCartState();
              } catch (error) {
                if (attempt >= 6) throw error;
                await new Promise((resolve) => window.setTimeout(resolve, 350));
                continue;
              }
              const orderLines = (cartState?.items || []).filter((item) => String(item?.properties?.['_Pioupiou large order token'] || '') === orderToken);
              const lineOriginal = (item) => {
                const direct = Number(item?.original_line_price);
                if (Number.isFinite(direct) && direct >= 0) return direct;
                return Math.max(0, Number(item?.original_price ?? item?.price ?? 0)) * Math.max(0, Number(item?.quantity || 0));
              };
              const originalTotal = orderLines.reduce((sum, item) => sum + lineOriginal(item), 0);
              const extraUnits = orderLines.reduce((sum, item) => {
                if (String(item?.properties?.['_Pioupiou extra'] || '') !== '1') return sum;
                return sum + Math.max(0, Number(item?.quantity || 0));
              }, 0);
              largePriceOk = originalTotal === expectedPackPrice && extraUnits === (packQuantity - 4);
              if (largePriceOk) break;
              if (attempt < 6) await new Promise((resolve) => window.setTimeout(resolve, 400));
            }
            /* V10.99 — même principe que le flux pack standard (V10.93) : si l'article est
               bien présent dans le panier, une vérification de prix qui traîne ne doit plus
               bloquer le client. Shopify checkout reste l'autorité finale sur le prix réel. */
            if (!largePriceOk && orderLines.length === 0) {
              throw new Error('Le Pack famille n’a pas pu être ajouté au panier. Réessayez dans quelques secondes.');
            }
            if (!largePriceOk && feedback) {
              feedback.textContent = 'Pack ajouté. Shopify finalise la synchronisation du panier…';
            }

            /* Le nouveau pack est confirmé : on peut maintenant retirer l'ancienne sélection.
               Un échec ici ne peut plus laisser le client avec un panier vide. */
            const largeCleanupUpdates = {};
            (cartState?.items || []).forEach((item) => {
              if (!item?.key) return;
              if (String(item?.properties?.['_Pioupiou large order token'] || '') === orderToken) return;
              largeCleanupUpdates[item.key] = 0;
            });
            if (Object.keys(largeCleanupUpdates).length) {
              let cleanupOk = false;
              let cleanupError = null;
              for (let cleanupAttempt = 0; cleanupAttempt < 2; cleanupAttempt += 1) {
                try {
                  const cleanupResponse = await fetchWithTimeout(cartUrl('cart/update.js'), {
                    method: 'POST',
                    headers: jsonHeaders,
                    credentials: 'same-origin',
                    body: JSON.stringify({ updates: largeCleanupUpdates })
                  }, 5000, 'Nettoyage du panier trop lent');
                  cleanupOk = cleanupResponse.ok;
                  if (cleanupOk) break;
                } catch (error) {
                  cleanupError = error;
                }
                if (!cleanupOk) await new Promise((resolve) => window.setTimeout(resolve, 250));
              }
              if (!cleanupOk) throw cleanupError || new Error('Le nouveau pack est prêt, mais l’ancienne sélection n’a pas pu être retirée. Rechargez la page puis réessayez.');
              cartState = await getCartState();
            }

            updateHeaderCartBadge(cartState);
            if (feedback) feedback.textContent = `${packQuantity} oreillers prêts. Une dernière option avant le paiement…`;
            if (label) label.textContent = 'Checkout prêt';
            if (mobileButton) mobileButton.textContent = 'Checkout prêt';

            const upsellResult = await runDirectCheckoutUpsell({
              packQuantity,
              freeGiftCount: 3,
              selectedAges,
              cartUrl,
              getCartState,
              checkoutUrl: '/checkout'
            });
            if (upsellResult?.navigating) return;
            if (upsellResult?.dismissed) {
              if (feedback) feedback.textContent = `${packQuantity} oreillers ajoutés au panier. Vous pouvez continuer vos achats ou reprendre le paiement.`;
              if (label) label.textContent = initialLabel;
              if (mobileButton) mobileButton.textContent = initialMobileLabel;
              if (button) button.disabled = false;
              if (mobileButton) mobileButton.disabled = false;
              return;
            }
            if (feedback) feedback.textContent = 'Ouverture du paiement…';
            navigateToCheckout('/checkout');
            return;
          }

          /* V151 - ne jamais vider le panier avant d'avoir confirme que le parent
             Shopify peut etre ajoute. Cela evite un clic Commander qui semble ne rien
             faire lorsque le produit parent n'est pas publie sur Boutique en ligne. */

          const technicalProperties = {
            '_Pioupiou bundle': '1',
            '_Pioupiou pack': String(packQuantity),
            '_Pioupiou oreillers': String(packQuantity),
            '_Pioupiou pack visuel': packConfig.image,
            '_Pioupiou configuration': selectedAges.map((age) => normalizeAge(age)).join('|'),
            '_Pioupiou bundle token': bundleToken,
            '_Pioupiou prix pack': String(expectedPackPrice),
            '_Pioupiou parent variant': String(parentVariantId),
            '_Pioupiou component variants': selectedComponentVariantIds.join('|')
          };
          /* Les informations privées sont dupliquées sur toutes les lignes afin que
             le panier sache toujours reconstruire le bundle. Les informations client
             ne sont ajoutées qu'à la première ligne pour éviter les répétitions. */
          /* V10.27 — boucle plutot que lignes figees : le nombre de housses
             offertes suit desormais le pack (1, 2 ou 3) sans code a rallonger. */
          [1, 2, 3].forEach((giftIndex) => {
            if (properties[`Housse offerte ${giftIndex}`]) {
              technicalProperties[`_Pioupiou housse ${giftIndex}`] = properties[`Housse offerte ${giftIndex}`];
            }
            if (properties[`Taille housse offerte ${giftIndex}`]) {
              technicalProperties[`_Pioupiou housse age ${giftIndex}`] = properties[`Taille housse offerte ${giftIndex}`];
            }
          });
          if (properties['_Housse offerte variante 1']) technicalProperties['_Housse offerte variante 1'] = properties['_Housse offerte variante 1'];
          if (properties['_Housse offerte variante 2']) technicalProperties['_Housse offerte variante 2'] = properties['_Housse offerte variante 2'];

          /* V10.62 — anti-double AddToCart.
             Si exactement le même pack/configuration est déjà dans le panier (cas
             typique : popup fermée puis nouveau clic sur Commander), on réutilise
             cette ligne au lieu de refaire cart/add.js. Cela évite un second
             product_added_to_cart inutile tout en conservant la possibilité de
             remplacer le panier si le client a réellement modifié son pack. */
          /* V10.90 — un panier configure avant une hausse de prix ne doit jamais
             etre reutilise tel quel. Le prix courant fait partie de l'identite du pack. */
          const matchingTechnicalKeys = [
            '_Pioupiou pack',
            '_Pioupiou configuration',
            '_Pioupiou housse 1',
            '_Pioupiou housse 2',
            '_Pioupiou housse 3',
            '_Pioupiou housse age 1',
            '_Pioupiou housse age 2',
            '_Pioupiou housse age 3',
            '_Housse offerte variante 1',
            '_Housse offerte variante 2',
            '_Pioupiou prix pack',
            '_Pioupiou parent variant'
          ];
          const configuredLineOriginalTotal = (item) => {
            const direct = Number(item?.original_line_price);
            if (Number.isFinite(direct) && direct >= 0) return direct;
            const unit = Number(item?.original_price ?? item?.price ?? 0);
            return Math.max(0, unit) * Math.max(0, Number(item?.quantity || 0));
          };
          const isSameConfiguredPack = (item) => {
            const itemProperties = item?.properties || {};
            const sameParent = Number(item?.variant_id || item?.id || 0) === parentVariantId
              || Number(itemProperties['_Pioupiou parent variant'] || 0) === parentVariantId;
            if (!sameParent || Number(item?.quantity || 0) !== 1) return false;
            if (configuredLineOriginalTotal(item) !== expectedPackPrice) return false;
            return matchingTechnicalKeys.every((key) =>
              String(itemProperties[key] || '') === String(technicalProperties[key] || '')
            );
          };

          /* Le contrôle anti-double est utile mais ne doit pas bloquer une première commande
             si /cart.js répond lentement sur un WebView ou un réseau mobile. */
          let stateAfterAdd = await getCartState().catch(() => ({ items: [], item_count: 0 }));
          let newlyAddedParent = (stateAfterAdd.items || []).find(isSameConfiguredPack) || null;
          const reusedExistingPack = Boolean(newlyAddedParent?.key);

          if (reusedExistingPack) {
            const previousToken = String(newlyAddedParent?.properties?.['_Pioupiou bundle token'] || '');
            if (previousToken) bundleToken = previousToken;
          } else {
            /* Le checkout doit recevoir le vrai produit parent du pack. Les variantes
               d'oreillers restent mémorisées dans les propriétés techniques. */
            const itemsToAdd = [{
              id: parentVariantId,
              quantity: 1,
              properties: { ...properties, ...technicalProperties }
            }];
            let addResponse = null;
            let addTimeoutError = null;
            try {
              addResponse = await fetchWithTimeout(cartUrl('cart/add.js'), {
                method: 'POST',
                headers: jsonHeaders,
                credentials: 'same-origin',
                body: JSON.stringify({ items: itemsToAdd })
              }, 7000, 'Ajout du pack trop lent. Vérifiez votre connexion puis réessayez.');
            } catch (error) {
              if (error?.code !== 'PIOUPIOU_TIMEOUT') throw error;
              addTimeoutError = error;
            }
            if (addResponse && !addResponse.ok) {
              let message = 'Le pack parent Shopify ne peut pas être ajouté.';
              try {
                const errorData = await addResponse.json();
                message = errorData?.description || errorData?.message || message;
              } catch (_) {}
              if (addResponse.status === 422 || /not available|indisponible|sold out|variant|introuvable|publie/i.test(message)) {
                message = `Pack ${packQuantity} indisponible sur la Boutique en ligne. Dans Shopify, ouvrez le produit parent puis Canaux de vente et applications > Gérer, et cochez Boutique en ligne. Variant : ${parentVariantId}.`;
              }
              throw new Error(message);
            }

            /* Si le navigateur a coupé l'attente après que Shopify a reçu le POST,
               on retrouve la ligne par son token au lieu d'afficher une fausse erreur. */
            stateAfterAdd = await getCartStateWithRetry(addTimeoutError ? 5 : 3).catch(() => null);
            newlyAddedParent = (stateAfterAdd?.items || []).find((item) =>
              String(item?.properties?.['_Pioupiou bundle token'] || '') === bundleToken
              && (Number(item?.variant_id || item?.id || 0) === parentVariantId
                || Number(item?.properties?.['_Pioupiou parent variant'] || 0) === parentVariantId)
            );
            if (!newlyAddedParent?.key) {
              if (addTimeoutError) throw addTimeoutError;
              throw new Error(`Shopify a accepté le Pack ${packQuantity}, mais la ligne parent n'a pas pu être identifiée. Rechargez la page et réessayez.`);
            }
          }

          /* Un seul pack/configuration reste actif. Si on réutilise un pack déjà
             présent, les éventuelles anciennes lignes annexes sont retirées avant
             de reproposer l'upsell : aucune housse payante ne reste silencieusement. */
          const cleanupUpdates = {};
          (stateAfterAdd.items || []).forEach((item) => {
            if (!item?.key) return;
            if (item.key === newlyAddedParent.key) {
              if (Number(item.quantity || 0) !== 1) cleanupUpdates[item.key] = 1;
            } else {
              cleanupUpdates[item.key] = 0;
            }
          });
          if (Object.keys(cleanupUpdates).length) {
            let cleanupOk = false;
            let cleanupError = null;
            for (let cleanupAttempt = 0; cleanupAttempt < 2; cleanupAttempt += 1) {
              try {
                const cleanupResponse = await fetchWithTimeout(cartUrl('cart/update.js'), {
                  method: 'POST',
                  headers: jsonHeaders,
                  credentials: 'same-origin',
                  body: JSON.stringify({ updates: cleanupUpdates })
                }, 5200, 'Nettoyage du panier trop lent');
                cleanupOk = cleanupResponse.ok;
                if (cleanupOk) break;
              } catch (error) { cleanupError = error; }
              if (!cleanupOk) await new Promise((resolve) => window.setTimeout(resolve, 250));
            }
            if (!cleanupOk) throw cleanupError || new Error('Le nouveau pack a été préparé, mais l’ancien panier n’a pas pu être remplacé proprement. Rechargez la page puis réessayez.');
          }

          /* V149 — compatibilité bundle parent Shopify / Cart Transform.
             Avant V149, le thème exigeait toujours N unités techniques après cart/add.js.
             Une vraie Cart Transform peut légitimement remplacer ces lignes par un parent
             "Lot de N oreillers Pioupiou". On accepte donc soit l'ancien contrat technique,
             soit le parent natif, tout en conservant le verrou de prix exact. */
          const normalizeBundleText = (value) => String(value || '')
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[–—−]/g, '-')
            .replace(/\s+/g, ' ')
            .trim();
          const isExpectedNativeBundleLine = (item) => {
            if (Number(item?.variant_id || item?.id || 0) === parentVariantId) return true;
            const text = normalizeBundleText([
              item?.product_title,
              item?.title,
              item?.product?.title,
              item?.handle,
              item?.url
            ].filter(Boolean).join(' '));
            if (!text || !text.includes('pioupiou')) return false;
            const patterns = [
              `lot de ${packQuantity} oreiller`,
              `pack ${packQuantity} oreiller`,
              `${packQuantity} oreillers pioupiou`
            ];
            return patterns.some((pattern) => text.includes(pattern));
          };
          const lineOriginalTotal = (item) => {
            const direct = Number(item?.original_line_price);
            if (Number.isFinite(direct) && direct >= 0) return direct;
            const unit = Number(item?.original_price ?? item?.price ?? 0);
            return Math.max(0, unit) * Math.max(0, Number(item?.quantity || 0));
          };
          const lineFinalTotal = (item) => {
            const direct = Number(item?.final_line_price);
            if (Number.isFinite(direct) && direct >= 0) return direct;
            const unit = Number(item?.final_price ?? item?.discounted_price ?? item?.price ?? 0);
            return Math.max(0, unit) * Math.max(0, Number(item?.quantity || 0));
          };
          const inspectBundleState = (state) => {
            const stateItems = Array.isArray(state?.items) ? state.items : [];
            const bundleLines = stateItems.filter((item) => String(item?.properties?.['_Pioupiou bundle token'] || '') === bundleToken);
            const bundleUnits = bundleLines.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
            const legacyStructureOk = Number(state?.item_count || 0) === packQuantity
              && bundleUnits === packQuantity
              && bundleLines.length > 0
              && bundleLines.every((item) => String(item?.properties?.['_Pioupiou pack'] || '') === String(packQuantity))
              && bundleLines.every((item) => String(item?.properties?.['_Pioupiou pack visuel'] || '') === packConfig.image);
            const nativeBundleLine = stateItems.find(isExpectedNativeBundleLine) || null;
            const nativeStructureOk = Boolean(nativeBundleLine)
              && Number(state?.item_count || 0) === 1
              && Number(nativeBundleLine?.quantity || 0) === 1;
            const priceLines = nativeBundleLine ? [nativeBundleLine] : bundleLines;
            const originalBundleTotal = priceLines.reduce((sum, item) => sum + lineOriginalTotal(item), 0);
            const finalBundleTotal = priceLines.reduce((sum, item) => sum + lineFinalTotal(item), 0);
            return {
              bundleLines,
              legacyStructureOk,
              nativeStructureOk,
              structureOk: legacyStructureOk || nativeStructureOk,
              originalBundleTotal,
              finalBundleTotal,
              priceOk: originalBundleTotal === expectedPackPrice && finalBundleTotal <= originalBundleTotal
            };
          };

          let cartState = null;
          let inspectedState = null;
          for (let attempt = 0; attempt < 7; attempt += 1) {
            try {
              cartState = await getCartState();
            } catch (error) {
              if (attempt >= 6) throw error;
              await new Promise((resolve) => window.setTimeout(resolve, 350));
              continue;
            }
            inspectedState = inspectBundleState(cartState);
            if (inspectedState.structureOk && inspectedState.priceOk) break;
            if (attempt < 6) await new Promise((resolve) => window.setTimeout(resolve, 400));
          }

          const finalInspection = inspectBundleState(cartState);
          const structureOk = finalInspection.structureOk;
          const priceOk = finalInspection.priceOk;

          /* V10.93 — après un cart/add accepté par Shopify, les contrôles de structure/prix
             restent diagnostiques mais ne bloquent plus l'acheteur. Les Cart Transforms,
             promotions et changements de tarif peuvent être asynchrones ; Shopify checkout
             reste l'autorité finale sur la ligne réellement vendable et son prix courant. */
          if ((!structureOk || !priceOk) && Number(cartState?.item_count || 0) <= 0) {
            throw new Error('Le panier est resté vide après l’ajout. Réessayez dans quelques secondes.');
          }
          if ((!structureOk || !priceOk) && feedback) {
            feedback.textContent = 'Pack ajouté. Shopify finalise la synchronisation du panier…';
          }

          updateHeaderCartBadge(cartState);
          if (feedback) feedback.textContent = reusedExistingPack
            ? `Pack ${packQuantity} déjà prêt dans votre panier. Une dernière option avant le paiement…`
            : `Pack ${packQuantity} prêt au bon prix. Une dernière option avant le paiement…`;
          if (label) label.textContent = 'Checkout prêt';
          if (mobileButton) mobileButton.textContent = 'Checkout prêt';

          /* V10.59 — on conserve le skip-cart, avec une seule micro-étape optionnelle.
             Le client peut refuser/fermer sans aucune modification du panier. */
          const upsellResult = await runDirectCheckoutUpsell({
            packQuantity,
            freeGiftCount: packConfig.gifts,
            selectedAges,
            cartUrl,
            getCartState,
            checkoutUrl: '/checkout'
          });

          /* Le bouton bleu lance /checkout. Une fermeture de la modale laisse le
             client sur la page avec son pack déjà présent dans le panier. */
          if (upsellResult?.navigating) return;
          if (upsellResult?.dismissed) {
            if (feedback) feedback.textContent = 'Pack ajouté au panier. Vous pouvez continuer vos achats ou reprendre le paiement.';
            if (label) label.textContent = initialLabel;
            if (mobileButton) mobileButton.textContent = initialMobileLabel;
            if (button) button.disabled = false;
            if (mobileButton) mobileButton.disabled = false;
            return;
          }
          if (feedback) feedback.textContent = 'Ouverture du paiement…';
          if (label) label.textContent = 'Ouverture du paiement…';
          if (mobileButton) mobileButton.textContent = 'Paiement…';
          navigateToCheckout('/checkout');
        } catch (error) {
          if (label) label.textContent = initialLabel;
          if (mobileButton) mobileButton.textContent = initialMobileLabel;
          const message = error instanceof Error ? error.message : 'Une erreur est survenue.';
          if (feedback) {
            feedback.textContent = message;
            feedback.classList.add('cart-feedback--error');
            feedback.setAttribute('role', 'alert');
            feedback.hidden = false;
            window.setTimeout(() => feedback.scrollIntoView({ behavior: 'smooth', block: 'center' }), 30);
          } else {
            window.alert(message);
          }
          if (button) button.disabled = false;
          if (mobileButton) mobileButton.disabled = false;
        }
      });
    });

    /* V142 — panier mobile/desktop : intégrité du pack + intégrité du prix.
       Les anciens paniers cumulés sont nettoyés automatiquement et le checkout est
       bloqué si le panier ne correspond pas exactement à l'offre 1/2/3/4 choisie. */
    document.querySelectorAll('[data-cart-form]').forEach((cartForm) => {
      const updateButton = cartForm.querySelector('[data-cart-update]');
      const checkoutButton = cartForm.querySelector('[data-cart-checkout]');
      const feedback = cartForm.querySelector('[data-cart-status]');
      const root = window.Shopify?.routes?.root || '/';
      const cartUrl = (path) => `${root}${path}`.replace(/\/{2,}/g, '/');
      const expectedTotal = Number.parseInt(cartForm.dataset.pioupiouExpectedTotal || '0', 10) || 0;
      const expectedPack = Number.parseInt(cartForm.dataset.pioupiouPack || '0', 10) || 0;
      const needsReset = cartForm.dataset.pioupiouCartReset === 'true';
      let updating = false;

      try {
        const cartParams = new URLSearchParams(window.location.search);
        if (cartParams.get('panier') === 'actualise' && feedback) {
          feedback.textContent = 'Votre panier a été actualisé au tarif en vigueur. Vos choix ont été conservés.';
          const cleanUrl = `${window.location.pathname}${window.location.hash || ''}`;
          window.history.replaceState({}, '', cleanUrl);
        }
      } catch (_) {}

      const getCartState = async () => {
        const response = await withTimeout(fetch(cartUrl('cart.js'), {
          headers: { 'Accept': 'application/json' },
          credentials: 'same-origin',
          cache: 'no-store'
        }), 4200, 'Vérification du panier trop lente');
        if (!response.ok) throw new Error('Impossible de vérifier le panier.');
        return response.json();
      };

      /* V10.90 — migration silencieuse des paniers crees avec un ancien tarif.
         On reconstruit le meme pack avec le parent Shopify courant, en conservant
         tailles et choix de housses. Les articles hors pack ne sont jamais touches. */
      const resetLegacyBundle = async () => {
        if (!needsReset) return;
        setCheckoutBusy(checkoutButton, true);
        if (updateButton) updateButton.disabled = true;
        if (feedback) feedback.textContent = 'Actualisation de votre panier au tarif en vigueur…';

        const parentVariants = {
          1: Number(document.body?.dataset?.pioupiouParentVariant1 || 58499777036552),
          2: Number(document.body?.dataset?.pioupiouParentVariant2 || 58499777134856),
          3: Number(document.body?.dataset?.pioupiouParentVariant3 || 58499777265928),
          4: Number(document.body?.dataset?.pioupiouParentVariant4 || 58499777331464)
        };
        const knownParentIds = new Set(Object.values(parentVariants).filter(Boolean));
        const expectedParentVariant = Number(parentVariants[expectedPack] || 0);
        const originalLineTotal = (item) => {
          const direct = Number(item?.original_line_price);
          if (Number.isFinite(direct) && direct >= 0) return direct;
          return Math.max(0, Number(item?.original_price ?? item?.price ?? 0)) * Math.max(0, Number(item?.quantity || 0));
        };
        const isBundleMarked = (item) => {
          const properties = item?.properties || {};
          return String(properties['_Pioupiou bundle'] || '') === '1'
            || Boolean(properties['_Pioupiou pack'])
            || Boolean(properties['Pack Pioupiou'])
            || Boolean(properties['_Pioupiou large order token']);
        };
        const isKnownParent = (item) => knownParentIds.has(Number(item?.variant_id || item?.id || 0));
        const isPaidCover = (item) => {
          const properties = item?.properties || {};
          return String(properties['_Pioupiou upsell'] || '') === 'Housse payante' && !isBundleMarked(item);
        };
        const isPillowLine = (item) => String(item?.handle || item?.product_handle || '') === 'oreiller-ergonomique-enfant-3-hauteurs-de-1-a-14-ans';

        const clearStaleSelection = async (state) => {
          const items = Array.isArray(state?.items) ? state.items : [];
          const updates = {};
          const recognizedOnly = items.length > 0 && items.every((item) => isBundleMarked(item) || isKnownParent(item) || isPillowLine(item) || isPaidCover(item));
          items.forEach((item) => {
            if (!item?.key) return;
            if (isBundleMarked(item) || isKnownParent(item) || (recognizedOnly && (isPillowLine(item) || isPaidCover(item)))) updates[item.key] = 0;
          });
          if (Object.keys(updates).length) {
            const response = await fetchWithTimeout(cartUrl('cart/update.js'), {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({ updates })
            }, 5200, 'Remise à zéro de l’ancien panier trop lente');
            if (!response.ok) throw new Error('Impossible de remettre l’ancienne sélection à zéro.');
          }
          window.location.replace(`${root}?panier=reset#packs-pioupiou`);
        };

        try {
          if (!expectedPack || !expectedTotal || !expectedParentVariant) {
            const state = await getCartState();
            await clearStaleSelection(state);
            return;
          }

          const state = await getCartState();
          const items = Array.isArray(state?.items) ? state.items : [];
          const sourceLine = items.find((item) => Number(item?.variant_id || item?.id || 0) === expectedParentVariant)
            || items.find((item) => String(item?.properties?.['_Pioupiou pack'] || '') === String(expectedPack))
            || items.find((item) => isBundleMarked(item));
          const sourceProperties = { ...(sourceLine?.properties || {}) };
          const hasConfiguration = Boolean(sourceProperties['_Pioupiou configuration']) || Boolean(sourceProperties['Oreiller 1']);

          if (!sourceLine || !hasConfiguration) {
            await clearStaleSelection(state);
            return;
          }

          const freshToken = `pioupiou-refresh-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
          const freshProperties = { ...sourceProperties };
          freshProperties['_Pioupiou bundle'] = '1';
          freshProperties['_Pioupiou pack'] = String(expectedPack);
          freshProperties['_Pioupiou oreillers'] = String(expectedPack);
          freshProperties['_Pioupiou prix pack'] = String(expectedTotal);
          freshProperties['_Pioupiou parent variant'] = String(expectedParentVariant);
          freshProperties['_Pioupiou bundle token'] = freshToken;

          let addResponse = null;
          let legacyTimeoutError = null;
          try {
            addResponse = await fetchWithTimeout(cartUrl('cart/add.js'), {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({ items: [{ id: expectedParentVariant, quantity: 1, properties: freshProperties }] })
            }, 7000, 'Actualisation du pack trop lente');
          } catch (error) {
            if (error?.code !== 'PIOUPIOU_TIMEOUT') throw error;
            legacyTimeoutError = error;
          }
          if (addResponse && !addResponse.ok) {
            const apiError = await addResponse.json().catch(() => null);
            const description = String(apiError?.description || apiError?.message || '').trim();
            throw new Error(description || 'Impossible d’actualiser le pack pour le moment.');
          }

          let afterAdd = null;
          let freshLines = [];
          let freshOriginalTotal = 0;
          for (let verifyAttempt = 0; verifyAttempt < (legacyTimeoutError ? 5 : 3); verifyAttempt += 1) {
            afterAdd = await getCartState().catch(() => null);
            freshLines = (afterAdd?.items || []).filter((item) => String(item?.properties?.['_Pioupiou bundle token'] || '') === freshToken);
            freshOriginalTotal = freshLines.reduce((sum, item) => sum + originalLineTotal(item), 0);
            if (freshLines.length && freshOriginalTotal === expectedTotal) break;
            if (verifyAttempt < (legacyTimeoutError ? 4 : 2)) await new Promise((resolve) => window.setTimeout(resolve, 300));
          }
          /* V10.99 — cohérent avec le reste du fichier : si l'article a bien été ajouté
             (freshLines non vide), on n'empêche plus la suite pour une histoire de délai
             de vérification du prix. On ne bloque que si l'ajout a réellement échoué. */
          if (!freshLines.length) {
            if (legacyTimeoutError) throw legacyTimeoutError;
            throw new Error('Le panier n’a pas pu être actualisé. Réessayez dans quelques secondes.');
          }

          const cleanupUpdates = {};
          (afterAdd.items || []).forEach((item) => {
            if (!item?.key) return;
            if (String(item?.properties?.['_Pioupiou bundle token'] || '') === freshToken) return;
            if (isBundleMarked(item) || isKnownParent(item)) cleanupUpdates[item.key] = 0;
          });
          if (Object.keys(cleanupUpdates).length) {
            const cleanupResponse = await fetchWithTimeout(cartUrl('cart/update.js'), {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({ updates: cleanupUpdates })
            }, 5200, 'Nettoyage de l’ancien panier trop lent');
            if (!cleanupResponse.ok) throw new Error('Le nouveau pack est prêt, mais l’ancien panier n’a pas pu être retiré proprement.');
          }

          const finalState = await getCartState();
          const finalFreshLines = (finalState.items || []).filter((item) => String(item?.properties?.['_Pioupiou bundle token'] || '') === freshToken);
          const finalOriginalTotal = finalFreshLines.reduce((sum, item) => sum + originalLineTotal(item), 0);
          if (!finalFreshLines.length || finalOriginalTotal !== expectedTotal) {
            throw new Error('Le panier n’a pas pu être validé au nouveau tarif.');
          }

          window.location.replace(`${cartUrl('cart')}?panier=actualise`);
        } catch (error) {
          setCheckoutBusy(checkoutButton, false);
          if (updateButton) updateButton.disabled = false;
          if (feedback) feedback.textContent = error instanceof Error ? error.message : 'Impossible d’actualiser votre panier.';
        }
      };

      if (needsReset) {
        resetLegacyBundle();
        return;
      }

      /* V178 — upsell housses réellement synchronisé avec Shopify.
         La sélection reste optionnelle, mais si elle est encore en attente au clic sur paiement,
         elle est ajoutée puis vérifiée dans /cart.js AVANT d'ouvrir le checkout. */
      let commitPendingUpsell = async () => null;
      const upsell = cartForm.querySelector('[data-cart-upsell]');
      if (upsell) {
        const upsellPanel = upsell.closest('[data-cart-upsell-panel]');
        const upsellToggle = upsellPanel?.querySelector('[data-cart-upsell-toggle]');
        const upsellBody = upsellPanel?.querySelector('[data-cart-upsell-body]');
        const setUpsellOpen = (open) => {
          if (!upsellPanel || !upsellToggle || !upsellBody) return;
          upsellPanel.classList.toggle('is-open', Boolean(open));
          upsellToggle.setAttribute('aria-expanded', String(Boolean(open)));
          upsellBody.hidden = !open;
        };
        setUpsellOpen(false);
        upsellToggle?.addEventListener('click', () => {
          const isOpen = upsellToggle.getAttribute('aria-expanded') === 'true';
          setUpsellOpen(!isOpen);
        });
        const choices = [...upsell.querySelectorAll('[data-cart-upsell-choice]')];
        const sizesWrap = upsell.querySelector('[data-cart-upsell-sizes]');
        const sizeButtons = [...upsell.querySelectorAll('[data-cart-upsell-size]')];
        const autoSizeWrap = upsell.querySelector('[data-cart-upsell-auto-size]');
        const autoSizeLabel = upsell.querySelector('[data-cart-upsell-auto-size-label]');
        const changeSizeButton = upsell.querySelector('[data-cart-upsell-change-size]');
        const defaultSize = String(upsell.dataset.defaultSize || '').trim();
        const actions = upsell.querySelector('[data-cart-upsell-actions]');
        const upsellAdd = upsell.querySelector('[data-cart-upsell-add]');
        const upsellStatus = upsell.querySelector('[data-cart-upsell-status]');
        const qtyOutput = upsell.querySelector('[data-cart-upsell-qty]');
        const qtyMinus = upsell.querySelector('[data-cart-upsell-minus]');
        const qtyPlus = upsell.querySelector('[data-cart-upsell-plus]');
        const currency = window.Shopify?.currency?.active || 'EUR';
        const moneyFormatter = new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', { style: 'currency', currency });
        const summaryTotal = cartForm.querySelector('[data-cart-summary-total]');
        let baseTotalCents = Math.max(0, Number.parseInt(summaryTotal?.dataset.cartTotalCents || '0', 10) || 0);
        let selectedVariantId = 0;
        let selectedUnitPriceCents = 0;
        let selectedSize = '';
        let quantity = 1;
        let revealActionsTimer = 0;

        const renderUpsellTotal = () => {
          /* V179 : ne jamais afficher un faux total avant confirmation Shopify.
             Le résumé reste sur le vrai cart.total_price jusqu’à l’ajout effectif. */
          if (!summaryTotal) return;
          summaryTotal.textContent = moneyFormatter.format(baseTotalCents / 100);
          summaryTotal.classList.remove('is-upsell-preview');
        };

        const renderQuantity = () => {
          quantity = Math.max(1, Math.min(12, quantity));
          if (qtyOutput) qtyOutput.textContent = String(quantity);
          if (qtyMinus) qtyMinus.disabled = quantity <= 1;
          if (qtyPlus) qtyPlus.disabled = quantity >= 12;
          if (upsellAdd) upsellAdd.textContent = quantity > 1 ? `Ajouter ${quantity} housses` : 'Ajouter la housse';
          renderUpsellTotal();
        };

        const clearSelection = () => {
          if (revealActionsTimer) { window.clearTimeout(revealActionsTimer); revealActionsTimer = 0; }
          selectedVariantId = 0;
          selectedUnitPriceCents = 0;
          selectedSize = '';
          choices.forEach((choice) => choice.setAttribute('aria-pressed', 'false'));
          sizeButtons.forEach((button) => button.setAttribute('aria-pressed', 'false'));
          if (sizesWrap) sizesWrap.hidden = true;
          if (autoSizeWrap) autoSizeWrap.hidden = true;
          if (actions) actions.hidden = true;
          if (upsellStatus) upsellStatus.textContent = '';
          renderUpsellTotal();
        };

        choices.forEach((choice) => {
          const variantId = Number.parseInt(choice.dataset.variantId || '0', 10);
          const fallbackUnitPriceCents = Math.max(0, Number.parseInt(choice.dataset.unitPriceCents || document.body?.dataset?.pioupiouCoverUpsellPrice || '999', 10) || 999);
          const price = choice.querySelector('[data-cart-upsell-price]');
          choice.addEventListener('click', () => {
            setUpsellOpen(true);
            const wasSelected = choice.getAttribute('aria-pressed') === 'true';
            if (wasSelected) {
              clearSelection();
              return;
            }
            if (revealActionsTimer) { window.clearTimeout(revealActionsTimer); revealActionsTimer = 0; }
            selectedVariantId = variantId;
            selectedUnitPriceCents = fallbackUnitPriceCents;
            selectedSize = defaultSize;
            quantity = 1;
            choices.forEach((item) => item.setAttribute('aria-pressed', item === choice ? 'true' : 'false'));
            sizeButtons.forEach((button) => {
              const active = selectedSize && String(button.dataset.cartUpsellSize || '').trim() === selectedSize;
              button.setAttribute('aria-pressed', String(Boolean(active)));
            });

            /* V10.45 — conserver le parcours progressif sans redemander l'âge :
               motif -> la taille déjà connue se déplie et est précochée -> quantité/Ajouter se déplient. */
            if (autoSizeLabel && defaultSize) autoSizeLabel.textContent = defaultSize;
            if (autoSizeWrap) autoSizeWrap.hidden = true;
            if (sizesWrap) sizesWrap.hidden = false;
            if (actions) actions.hidden = true;
            renderQuantity();

            if (selectedSize && actions) {
              revealActionsTimer = window.setTimeout(() => {
                if (!selectedVariantId || !selectedSize) return;
                actions.hidden = false;
                revealActionsTimer = 0;
              }, 180);
            }
            if (upsellStatus) upsellStatus.textContent = '';
          });
          /* V180 : l'ID et le prix proviennent du vrai produit Shopify rendu par Liquid.
             Aucun endpoint /variants/... ni ID figé n'est requis ici. */
          if (variantId && price) {
            const cents = fallbackUnitPriceCents;
            choice.dataset.unitPriceCents = String(cents);
            price.textContent = moneyFormatter.format(cents / 100);
          }
        });

        changeSizeButton?.addEventListener('click', () => {
          if (!selectedVariantId) return;
          if (autoSizeWrap) autoSizeWrap.hidden = true;
          if (sizesWrap) sizesWrap.hidden = false;
          if (actions) actions.hidden = !selectedSize;
        });

        sizeButtons.forEach((button) => {
          button.addEventListener('click', () => {
            if (!selectedVariantId) return;
            if (revealActionsTimer) { window.clearTimeout(revealActionsTimer); revealActionsTimer = 0; }
            selectedSize = String(button.dataset.cartUpsellSize || '').trim();
            sizeButtons.forEach((item) => item.setAttribute('aria-pressed', item === button ? 'true' : 'false'));
            if (autoSizeWrap) autoSizeWrap.hidden = true;
            quantity = 1;
            renderQuantity();
            if (actions) actions.hidden = !selectedSize;
            if (upsellStatus) upsellStatus.textContent = '';
          });
        });

        qtyMinus?.addEventListener('click', () => { quantity -= 1; renderQuantity(); });
        qtyPlus?.addEventListener('click', () => { quantity += 1; renderQuantity(); });
        renderQuantity();

        commitPendingUpsell = async () => {
          /* L’upsell reste strictement optionnel : sans motif + taille complets, le checkout continue sans ajout. */
          if (!selectedVariantId || !selectedSize) return null;
          const variantIdToAdd = selectedVariantId;
          const sizeToAdd = selectedSize;
          const quantityToAdd = Math.max(1, Math.min(12, quantity));
          const before = await getCartState();
          const unitsForVariant = (state, variantId) => (Array.isArray(state?.items) ? state.items : [])
            .filter((item) => Number(item?.variant_id || item?.id || 0) === variantId)
            .reduce((sum, item) => sum + Number(item?.quantity || 0), 0);
          const unitsBefore = unitsForVariant(before, variantIdToAdd);

          /* V180 — ID de variante résolu par Shopify/Liquid, puis ajout Ajax standard.
             Simple Bundles ne reçoit aucune propriété de bundle sur cette ligne payante. */
          const addPaidCover = async () => {
            if (!Number.isSafeInteger(variantIdToAdd) || variantIdToAdd <= 0) {
              throw new Error('La housse sélectionnée n’est pas disponible.');
            }
            /* V181 — ajout d’une seule variante avec le format natif Shopify.
               Pas de payload items[] : la housse reste une ligne indépendante des bundles. */
            const payload = new URLSearchParams();
            payload.set('id', String(variantIdToAdd));
            payload.set('quantity', String(quantityToAdd));
            payload.set('properties[Taille de la housse]', sizeToAdd);
            payload.set('properties[_Pioupiou upsell]', 'Housse payante');
            const response = await fetchWithTimeout(cartUrl('cart/add.js'), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'Accept': 'application/json'
              },
              credentials: 'same-origin',
              body: payload.toString()
            }, 4200, 'Ajout de la housse trop lent');
            if (!response.ok) {
              const apiError = await response.json().catch(() => null);
              const description = String(apiError?.description || apiError?.message || '').trim();
              throw new Error(description || 'Impossible d’ajouter la housse pour le moment.');
            }
            return response.json().catch(() => null);
          };

          let addCoverError = null;
          try {
            await addPaidCover();
          } catch (error) {
            addCoverError = error;
            if (error?.code !== 'PIOUPIOU_TIMEOUT') throw error;
          }

          /* En cas de timeout, vérifier d'abord le panier avant de proposer un retry :
             le serveur peut avoir validé l'ajout juste avant l'annulation navigateur. */
          let after = null;
          let unitsAfter = unitsBefore;
          for (let verifyAttempt = 0; verifyAttempt < (addCoverError ? 4 : 2); verifyAttempt += 1) {
            after = await getCartState().catch(() => null);
            unitsAfter = unitsForVariant(after, variantIdToAdd);
            if (unitsAfter >= unitsBefore + quantityToAdd) break;
            if (verifyAttempt < (addCoverError ? 3 : 1)) await new Promise((resolve) => window.setTimeout(resolve, 250));
          }
          if (unitsAfter < unitsBefore + quantityToAdd) {
            if (addCoverError) throw addCoverError;
            throw new Error('La housse n’a pas été confirmée dans le panier. Réessayez avant le paiement.');
          }

          baseTotalCents = Math.max(0, Number(after?.total_price || 0));
          if (summaryTotal) {
            summaryTotal.dataset.cartTotalCents = String(baseTotalCents);
            summaryTotal.textContent = moneyFormatter.format(baseTotalCents / 100);
            summaryTotal.classList.remove('is-upsell-preview');
          }
          clearSelection();
          if (upsellStatus) upsellStatus.textContent = quantityToAdd > 1 ? `${quantityToAdd} housses ajoutées au panier.` : 'Housse ajoutée au panier.';
          return after;
        };

        upsellAdd?.addEventListener('click', async () => {
          if (!selectedVariantId || upsellAdd.disabled) return;
          upsellAdd.disabled = true;
          const initialText = upsellAdd.textContent;
          upsellAdd.textContent = 'Ajout…';
          if (upsellStatus) upsellStatus.textContent = '';
          try {
            await commitPendingUpsell();
            window.location.assign(cartUrl('cart'));
          } catch (error) {
            upsellAdd.disabled = false;
            upsellAdd.textContent = initialText || 'Ajouter la housse';
            if (upsellStatus) upsellStatus.textContent = error instanceof Error ? error.message : 'Une erreur est survenue.';
          }
        });
      }

      const updateCart = async () => {
        if (updating) return;
        updating = true;
        if (updateButton) {
          updateButton.disabled = true;
          updateButton.textContent = 'Mise à jour…';
        }
        if (feedback) feedback.textContent = '';
        try {
          const updates = {};
          cartForm.querySelectorAll('[data-cart-line-key]').forEach((input) => {
            const key = input.dataset.cartLineKey || '';
            const quantity = Math.max(0, Number.parseInt(input.value || '0', 10) || 0);
            if (key) updates[key] = quantity;
          });
          const response = await fetchWithTimeout(cartUrl('cart/update.js'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ updates })
          }, 5200, 'Mise à jour du panier trop lente');
          if (!response.ok) throw new Error('Impossible de mettre le panier à jour pour le moment.');
          window.location.assign(cartUrl('cart'));
        } catch (error) {
          updating = false;
          if (updateButton) {
            updateButton.disabled = false;
            updateButton.textContent = 'Mettre à jour le panier';
          }
          if (feedback) feedback.textContent = error instanceof Error ? error.message : 'Une erreur est survenue.';
        }
      };

      /* Empêche Enter ou un submit implicite mobile de choisir le bouton paiement. */
      cartForm.addEventListener('submit', (event) => {
        event.preventDefault();
        updateCart();
      });
      updateButton?.addEventListener('click', updateCart);

      checkoutButton?.addEventListener('click', async (event) => {
        /* V10.93 — le <a href="/checkout"> reste le filet de sécurité natif.
           Le JS ne fait qu'une vérification courte et non bloquante. */
        if (event) event.preventDefault();
        const nativeTarget = checkoutButton.getAttribute('data-native-checkout-href') || '/checkout';
        if (checkoutButton.getAttribute('aria-busy') === 'true') return;
        setCheckoutBusy(checkoutButton, true);
        const initialHtml = checkoutButton.innerHTML;
        checkoutButton.textContent = 'Préparation du paiement…';
        if (feedback) feedback.textContent = '';

        const proceed = () => {
          setCheckoutBusy(checkoutButton, false);
          checkoutButton.innerHTML = initialHtml;
          navigateToCheckout(nativeTarget);
        };

        try {
          /* V10.98 — si le client a choisi une housse dans le panier puis clique
             directement sur paiement, on respecte son choix. L'upsell reste toutefois
             optionnel : un échec ou un timeout n'empêche jamais l'ouverture du checkout. */
          try {
            await withTimeout(commitPendingUpsell(), 5200, 'Ajout optionnel trop lent');
          } catch (upsellError) {
            if (feedback) feedback.textContent = 'La housse optionnelle n’a pas pu être confirmée — ouverture du paiement sans blocage…';
          }

          /* On ne bloque plus le paiement sur une différence de structure transitoire
             Simple Bundles / Cart Transform. Shopify reste l'autorité finale. */
          const state = await withTimeout(getCartState(), 2800, 'Vérification lente');
          if (!state || !Array.isArray(state.items) || state.items.length === 0) {
            setCheckoutBusy(checkoutButton, false);
            checkoutButton.innerHTML = initialHtml;
            if (feedback) feedback.textContent = 'Votre panier est vide. Retour à l’offre…';
            window.location.assign(`${root}#packs-pioupiou`);
            return;
          }
          proceed();
        } catch (error) {
          /* Réseau faible, WebView Meta, Safari privé, extension, etc. : le lien natif
             prend le relais au lieu d'afficher une erreur et de perdre la vente. */
          if (feedback) feedback.textContent = 'Connexion lente détectée — ouverture sécurisée du paiement…';
          window.setTimeout(proceed, 120);
        }
      });
    });

    document.querySelectorAll('.faq-list details').forEach((details) => details.addEventListener('toggle', () => {
      if (!details.open) return;
      document.querySelectorAll('.faq-list details').forEach((other) => { if (other !== details) other.open = false; });
    }));

    document.querySelectorAll('.purchase__faq').forEach((faq) => {
      const button = faq.querySelector('[data-faq-expand]');
      const extras = [...faq.querySelectorAll('.faq-item--extra')];
      if (!button || !extras.length) return;

      const label = button.querySelector('[data-faq-expand-label]');
      const setExpanded = (expanded) => {
        faq.classList.toggle('is-expanded', expanded);
        button.setAttribute('aria-expanded', String(expanded));
        if (label) label.textContent = expanded ? 'Voir moins' : 'Voir plus';
      };

      setExpanded(false);
      button.addEventListener('click', () => setExpanded(!faq.classList.contains('is-expanded')));
    });

    let activeDialogTrigger = null;
    let dialogScrollY = 0;
    const lockDialogScroll = () => {
      document.documentElement.classList.add('dialog-open');
      document.body.classList.add('dialog-open');
    };
    const unlockDialogScroll = () => {
      document.documentElement.classList.remove('dialog-open');
      document.body.classList.remove('dialog-open');
    };
    const openDialog = (dialog, trigger) => {
      if (!dialog) return;
      activeDialogTrigger = trigger || document.activeElement;
      dialogScrollY = window.scrollY;
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      lockDialogScroll();
      window.requestAnimationFrame(() => {
        const focusTarget = dialog.querySelector('[data-size-close],[data-klarna-close],[data-cert-close],button,[href],select,input');
        focusTarget?.focus({ preventScroll: true });
        if (Math.abs(window.scrollY - dialogScrollY) > 1) window.scrollTo({ top: dialogScrollY, left: 0, behavior: 'auto' });
      });
    };
    const resetDialogState = () => {
      unlockDialogScroll();
      if (Math.abs(window.scrollY - dialogScrollY) > 1) window.scrollTo({ top: dialogScrollY, left: 0, behavior: 'auto' });
      if (activeDialogTrigger instanceof HTMLElement) activeDialogTrigger.focus({ preventScroll: true });
      activeDialogTrigger = null;
    };
    const closeDialog = (dialog) => {
      if (!dialog) return;
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
      window.requestAnimationFrame(resetDialogState);
    };
    const dialogFor = (button, fallbackSelector) => {
      const targetId = button.getAttribute('aria-controls');
      return (targetId && document.getElementById(targetId)) || document.querySelector(fallbackSelector);
    };

    document.querySelectorAll('[data-size-guide]').forEach((button) => button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      openDialog(dialogFor(button, '[data-size-dialog]'), button);
    }));
    document.querySelectorAll('[data-size-close]').forEach((button) => button.addEventListener('click', (event) => {
      event.preventDefault();
      closeDialog(button.closest('[data-size-dialog]'));
    }));
    document.querySelectorAll('[data-size-dialog]').forEach((dialog) => dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog(dialog);
    }));


    document.querySelectorAll('[data-video-open]').forEach((button) => button.addEventListener('click', (event) => {
      event.preventDefault();
      const dialog = dialogFor(button, '[data-video-dialog]');
      if (!dialog) return;
      const player = dialog.querySelector('[data-video-player]');
      const title = dialog.querySelector('[data-video-dialog-title]');
      if (title) title.textContent = button.dataset.videoTitle || 'Pioupiou en vrai';
      if (player) {
        player.pause();
        player.src = button.dataset.videoSrc || '';
        player.poster = button.dataset.videoPoster || '';
        player.load();
      }
      openDialog(dialog, button);
      if (player) window.setTimeout(() => player.play().catch(() => {}), 80);
    }));
    document.querySelectorAll('[data-video-close]').forEach((button) => button.addEventListener('click', (event) => {
      event.preventDefault();
      closeDialog(button.closest('[data-video-dialog]'));
    }));
    document.querySelectorAll('[data-video-dialog]').forEach((dialog) => {
      const resetVideo = () => {
        const player = dialog.querySelector('[data-video-player]');
        if (!player) return;
        player.pause();
        player.removeAttribute('src');
        player.load();
      };
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closeDialog(dialog);
      });
      dialog.addEventListener('close', resetVideo);
    });

    document.querySelectorAll('[data-cert-open]').forEach((button) => button.addEventListener('click', (event) => {
      event.preventDefault();
      openDialog(dialogFor(button, '[data-cert-dialog]'), button);
    }));
    document.querySelectorAll('[data-cert-close]').forEach((button) => button.addEventListener('click', () => closeDialog(button.closest('[data-cert-dialog]'))));
    document.querySelectorAll('[data-cert-dialog]').forEach((dialog) => dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog(dialog);
    }));

    document.querySelectorAll('[data-klarna-info]').forEach((button) => button.addEventListener('click', () => openDialog(dialogFor(button, '[data-klarna-dialog]'), button)));

    /* V47 — un seul bénéfice visible à la fois sur mobile, en rotation automatique */
    document.querySelectorAll('[data-benefit-rotator]').forEach((group) => {
      const items = [...group.querySelectorAll('article')];
      if (items.length < 2) return;
      const mobileQuery = window.matchMedia('(max-width: 760px)');
      let current = 0;
      let timer = null;
      let resumeTimer = null;

      const clearTimers = () => {
        if (timer) window.clearInterval(timer);
        if (resumeTimer) window.clearTimeout(resumeTimer);
        timer = null;
        resumeTimer = null;
      };

      const activate = (index) => {
        items.forEach((item, itemIndex) => {
          item.classList.toggle('is-active', itemIndex === index);
          item.setAttribute('aria-hidden', mobileQuery.matches ? String(itemIndex !== index) : 'false');
        });
      };

      const start = () => {
        clearTimers();
        if (!mobileQuery.matches) {
          items.forEach((item) => {
            item.classList.remove('is-active');
            item.setAttribute('aria-hidden', 'false');
          });
          return;
        }
        activate(current);
        timer = window.setInterval(() => {
          current = (current + 1) % items.length;
          activate(current);
        }, 2600);
      };

      const pauseThenResume = () => {
        if (!mobileQuery.matches) return;
        clearTimers();
        resumeTimer = window.setTimeout(start, 4200);
      };

      group.addEventListener('touchstart', pauseThenResume, { passive: true });
      group.addEventListener('mouseenter', pauseThenResume);
      group.addEventListener('mouseleave', start);
      mobileQuery.addEventListener?.('change', start);
      window.addEventListener('resize', start);
      start();
    });

    document.querySelectorAll('[data-klarna-close]').forEach((button) => button.addEventListener('click', () => closeDialog(button.closest('[data-klarna-dialog]'))));
    document.querySelectorAll('[data-klarna-dialog]').forEach((dialog) => dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog(dialog);
    }));

    document.querySelectorAll('[data-size-dialog],[data-klarna-dialog],[data-cert-dialog]').forEach((dialog) => {
      dialog.addEventListener('cancel', () => window.requestAnimationFrame(resetDialogState));
      dialog.addEventListener('close', () => window.requestAnimationFrame(resetDialogState));
    });

    // V46: carousel automatique des micro-bénéfices sur mobile.
    document.querySelectorAll('.product-benefit-bubbles').forEach((track) => {
      const cards = [...track.children].filter((el) => el instanceof HTMLElement);
      if (cards.length < 2) return;
      const mobileMq = window.matchMedia('(max-width: 760px)');
      const reduceMq = window.matchMedia('(prefers-reduced-motion: reduce)');
      let timer = null;
      let resumeTimer = null;
      let index = 0;

      const nearestIndex = () => {
        const center = track.scrollLeft + track.clientWidth / 2;
        let best = 0;
        let distance = Infinity;
        cards.forEach((card, i) => {
          const cardCenter = card.offsetLeft + card.offsetWidth / 2;
          const d = Math.abs(cardCenter - center);
          if (d < distance) { distance = d; best = i; }
        });
        return best;
      };
      const goTo = (i, smooth = true) => {
        if (!mobileMq.matches) return;
        index = (i + cards.length) % cards.length;
        const card = cards[index];
        const left = Math.max(0, card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2);
        track.scrollTo({ left, behavior: smooth ? 'smooth' : 'auto' });
      };
      const stop = () => { if (timer) clearInterval(timer); timer = null; };
      const start = () => {
        stop();
        if (!mobileMq.matches || reduceMq.matches) return;
        timer = window.setInterval(() => goTo(index + 1), 2600);
      };
      const pauseForInteraction = () => {
        stop();
        index = nearestIndex();
        if (resumeTimer) clearTimeout(resumeTimer);
        resumeTimer = window.setTimeout(start, 6500);
      };

      ['touchstart','pointerdown','wheel'].forEach((name) => track.addEventListener(name, pauseForInteraction, { passive:true }));
      track.addEventListener('scroll', () => { index = nearestIndex(); }, { passive:true });
      const refresh = () => {
        if (mobileMq.matches) { goTo(nearestIndex(), false); start(); }
        else { stop(); track.scrollTo({ left:0, behavior:'auto' }); }
      };
      if (mobileMq.addEventListener) mobileMq.addEventListener('change', refresh);
      if (reduceMq.addEventListener) reduceMq.addEventListener('change', refresh);
      window.addEventListener('resize', refresh, { passive:true });
      refresh();
    });


    /* V10.54 — délai livraison cohérent partout : 48 h max d’expédition + jusqu’à 5 jours d’acheminement. */
    const addCalendarDays = (date, days) => {
      const result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
    };

    const formatDeliveryDate = (date) => new Intl.DateTimeFormat('fr-FR', {
      day: 'numeric',
      month: 'short'
    }).format(date).replace('.', '');

    const refreshDeliveryEstimates = () => {
      const now = new Date();
      const estimatedDeliveryDate = addCalendarDays(now, 7);
      const deliveryLabel = formatDeliveryDate(estimatedDeliveryDate);

      document.querySelectorAll('[data-delivery-estimate]').forEach((module) => {
        const output = module.querySelector('[data-delivery-date]');
        if (output) output.textContent = deliveryLabel;
      });
    };

    refreshDeliveryEstimates();

    /* V49 — comparatif nuit : éclairage progressif des avantages Pioupiou */
    document.querySelectorAll('[data-night-comparison]').forEach((comparison) => {
      const rows = [...comparison.querySelectorAll('[data-comparison-row]')];
      if (!rows.length) return;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let index = 0;
      let timer = null;

      const lightRow = (nextIndex) => {
        index = (nextIndex + rows.length) % rows.length;
        rows.forEach((row, rowIndex) => row.classList.toggle('is-lit', rowIndex === index));
      };
      const stop = () => {
        if (timer) window.clearInterval(timer);
        timer = null;
      };
      const start = () => {
        stop();
        if (reduceMotion.matches) {
          rows.forEach((row) => row.classList.add('is-lit-static'));
          return;
        }
        comparison.classList.add('is-awake');
        lightRow(index);
        timer = window.setInterval(() => lightRow(index + 1), 1450);
      };

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(([entry]) => {
          if (entry.isIntersecting) start();
          else stop();
        }, { threshold: 0.28 });
        observer.observe(comparison);
      } else start();

      comparison.addEventListener('pointerenter', stop);
      comparison.addEventListener('pointerleave', start);
      comparison.addEventListener('touchstart', stop, { passive: true });
      comparison.addEventListener('touchend', () => window.setTimeout(start, 1800), { passive: true });
      reduceMotion.addEventListener?.('change', start);
    });

    /* V184 — vidéos à la demande : aucun MP4 n'est demandé avant un clic/tap. */
    const storyMedias = [...document.querySelectorAll("[data-video-story-media]")];
    if (storyMedias.length) {
      const playIcon = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M8 6.5v11l9-5.5-9-5.5Z" fill="currentColor"/></svg>';
      const loadedVideos = new Set();

      const updateVideoUi = (video) => {
        const media = video.closest("[data-video-story-media]");
        if (!media) return;
        const playButton = media.querySelector("[data-video-play]");
        const isPlaying = !video.paused && !video.ended;
        media.classList.toggle("is-playing", isPlaying);
        if (playButton) {
          playButton.innerHTML = playIcon;
          playButton.hidden = isPlaying;
          playButton.setAttribute("aria-hidden", isPlaying ? "true" : "false");
          playButton.setAttribute("aria-label", isPlaying ? "Vidéo en cours de lecture" : "Lire la vidéo");
        }
      };

      const pauseOtherStories = (current) => {
        loadedVideos.forEach((other) => {
          if (other !== current && !other.paused) other.pause();
          if (other !== current) updateVideoUi(other);
        });
      };

      const wireVideo = (video) => {
        if (video.dataset.pioupiouWired === "true") return;
        video.dataset.pioupiouWired = "true";
        loadedVideos.add(video);
        const media = video.closest("[data-video-story-media]");
        const playButton = media?.querySelector("[data-video-play]");
        video.controls = false;
        video.setAttribute("playsinline", "");
        video.setAttribute("webkit-playsinline", "");
        video.setAttribute("role", "button");
        video.setAttribute("aria-pressed", "false");
        video.style.cursor = "pointer";

        const toggleVideo = () => {
          if (video.paused || video.ended) {
            pauseOtherStories(video);
            const playPromise = video.play();
            if (playPromise && typeof playPromise.catch === "function") playPromise.catch(() => updateVideoUi(video));
          } else video.pause();
        };

        video.addEventListener("click", (event) => { event.preventDefault(); toggleVideo(); });
        video.addEventListener("keydown", (event) => {
          if (event.key !== "Enter" && event.key !== " ") return;
          event.preventDefault();
          toggleVideo();
        });
        video.addEventListener("play", () => { pauseOtherStories(video); video.setAttribute("aria-pressed", "true"); updateVideoUi(video); });
        video.addEventListener("playing", () => updateVideoUi(video));
        video.addEventListener("pause", () => { video.setAttribute("aria-pressed", "false"); updateVideoUi(video); });
        video.addEventListener("ended", () => { video.setAttribute("aria-pressed", "false"); updateVideoUi(video); });
        if (playButton) playButton.onclick = (event) => { event.preventDefault(); event.stopPropagation(); toggleVideo(); };
      };

      const loadStoryVideo = (media) => {
        let video = media.querySelector("video[data-video-story]");
        if (video) return video;
        const placeholder = media.querySelector("[data-video-story-placeholder]");
        const src = placeholder?.dataset.videoSrc;
        if (!src) return null;
        const poster = media.querySelector(".video-story-card__poster");
        video = document.createElement("video");
        video.dataset.videoStory = "";
        video.src = src;
        video.preload = document.documentElement.classList.contains('piou-conn-slow') ? "metadata" : "auto";
        video.playsInline = true;
        video.setAttribute("webkit-playsinline", "");
        video.setAttribute("tabindex", "0");
        video.setAttribute("aria-label", placeholder.dataset.videoLabel || "Vidéo Pioupiou");
        if (poster?.currentSrc || poster?.src) video.poster = poster.currentSrc || poster.src;
        poster?.replaceWith(video);
        wireVideo(video);
        return video;
      };

      storyMedias.forEach((media) => {
        const button = media.querySelector("[data-video-play]");
        if (!button) return;
        button.addEventListener("click", (event) => {
          if (media.querySelector("video[data-video-story]")) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          const video = loadStoryVideo(media);
          if (!video) return;
          pauseOtherStories(video);
          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === "function") playPromise.catch(() => updateVideoUi(video));
        }, { capture: true });
        media.addEventListener("click", (event) => {
          if (event.target.closest("[data-video-play]") || media.querySelector("video[data-video-story]")) return;
          const video = loadStoryVideo(media);
          if (!video) return;
          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === "function") playPromise.catch(() => updateVideoUi(video));
        });
      });
    }


  });
})();

/* V140 — retrait d'un pack = vider les lignes techniques du bundle en une action. */
document.addEventListener('click', async (event) => {
  const clearButton = event.target.closest('[data-cart-clear]');
  if (!clearButton) return;
  event.preventDefault();
  if (clearButton.disabled) return;
  const initialText = clearButton.textContent;
  const root = window.Shopify?.routes?.root || '/';
  const cartUrl = (path) => `${root}${path}`.replace(/\/{2,}/g, '/');
  try {
    clearButton.disabled = true;
    clearButton.textContent = 'Retrait…';
    const response = await fetch(cartUrl('cart/clear.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin'
    });
    if (!response.ok) throw new Error('Impossible de retirer le pack.');
    window.location.assign(cartUrl('cart'));
  } catch (_) {
    clearButton.disabled = false;
    clearButton.textContent = initialText;
  }
});


/* V146 - cart bundle thumbnails are enforced client-side as a safety net.
   This also covers carts rendered/re-rendered by newer dynamic markup. */
(() => {
  const isCartPage = () => /^\/cart\/?$/i.test(window.location.pathname || '');

  const bundleAssets = () => {
    const body = document.body;
    if (!body) return {};
    return {
      1: body.getAttribute('data-pioupiou-bundle-one') || '',
      2: body.getAttribute('data-pioupiou-bundle-two') || '',
      3: body.getAttribute('data-pioupiou-bundle-three') || '',
      4: body.getAttribute('data-pioupiou-bundle-four') || '',
      fiveplus: body.getAttribute('data-pioupiou-bundle-fiveplus') || ''
    };
  };

  const quantityFromText = (value) => {
    const text = String(value || '').replace(/\s+/g, ' ').trim();
    const patterns = [
      /(\d+)\s*oreillers?\s*pioupiou/i,
      /(?:x|\u00d7)\s*(\d+)/i,
      /(\d+)\s*unites?\s+de\s+cette\s+ligne/i
    ];
    for (const pattern of patterns) {
      const match = text.match(pattern);
      if (match) {
        const number = Number(match[1]);
        if (Number.isFinite(number) && number > 0) return number;
      }
    }
    return 0;
  };

  const quantityFromContainer = (container, fallback) => {
    if (!container) return fallback || 0;
    const numberInput = container.querySelector('input[type="number"]');
    if (numberInput) {
      const number = Number(numberInput.value || numberInput.getAttribute('value') || 0);
      if (Number.isFinite(number) && number > 0) return number;
    }
    const dataQuantityNode = container.querySelector('[data-quantity],[data-cart-quantity],[data-item-quantity]');
    if (dataQuantityNode) {
      const raw = dataQuantityNode.getAttribute('data-quantity')
        || dataQuantityNode.getAttribute('data-cart-quantity')
        || dataQuantityNode.getAttribute('data-item-quantity')
        || dataQuantityNode.textContent;
      const number = Number(String(raw || '').replace(/[^0-9.]/g, ''));
      if (Number.isFinite(number) && number > 0) return number;
    }
    return quantityFromText(container.textContent) || fallback || 0;
  };

  const desiredBundleUrl = (quantity, assets) => {
    if (quantity >= 5) return assets.fiveplus || '';
    return assets[quantity] || '';
  };

  const findProductContainer = (titleNode) => {
    let current = titleNode;
    for (let depth = 0; depth < 9 && current; depth += 1, current = current.parentElement) {
      if (current.querySelector && current.querySelector('img')) {
        const text = String(current.textContent || '');
        const hasQuantity = quantityFromText(text) > 0
          || current.querySelector('input[type="number"],[data-quantity],[data-cart-quantity],[data-item-quantity]');
        if (hasQuantity) return current;
      }
    }
    return null;
  };

  const findProductImage = (container) => {
    if (!container) return null;
    const images = [...container.querySelectorAll('img')];
    if (!images.length) return null;
    const best = images.find((image) => {
      const descriptor = `${image.getAttribute('alt') || ''} ${image.getAttribute('src') || ''}`;
      return /oreiller|pillow|product/i.test(descriptor)
        && !/housse|cover|payment|logo|mascotte|review|avis/i.test(descriptor);
    });
    if (best) return best;
    return images.find((image) => {
      const rect = image.getBoundingClientRect();
      return rect.width >= 70 && rect.height >= 70;
    }) || images[0];
  };

  const patchCartBundleImages = () => {
    if (!isCartPage()) return;
    const main = document.getElementById('MainContent') || document.querySelector('main') || document.body;
    if (!main) return;
    const assets = bundleAssets();
    if (!assets.fiveplus) return;

    const globalQuantity = quantityFromText(main.textContent);
    const titleNodes = [...main.querySelectorAll('h1,h2,h3,h4,h5,h6,a,strong,b,p,span')]
      .filter((node) => /oreiller pioupiou/i.test(String(node.textContent || '')));

    const seen = new Set();
    titleNodes.forEach((titleNode) => {
      const container = findProductContainer(titleNode);
      if (!container || seen.has(container)) return;
      seen.add(container);

      const quantity = quantityFromContainer(container, globalQuantity);
      if (!quantity) return;
      const desired = desiredBundleUrl(quantity, assets);
      if (!desired) return;
      const image = findProductImage(container);
      if (!image) return;

      if (!image.dataset.pioupiouOriginalSrc) {
        image.dataset.pioupiouOriginalSrc = image.getAttribute('src') || '';
      }
      if (image.getAttribute('src') !== desired || image.dataset.pioupiouBundleQuantity !== String(quantity)) {
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.setAttribute('src', desired);
        image.setAttribute('loading', 'eager');
        image.setAttribute('decoding', 'async');
        image.dataset.pioupiouBundleQuantity = String(quantity);
        image.setAttribute('alt', quantity >= 5
          ? 'Selection Pioupiou de 5 oreillers et plus'
          : `Pack Pioupiou ${quantity} oreiller${quantity > 1 ? 's' : ''}`);
      }
    });
  };

  const run = () => {
    patchCartBundleImages();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  document.addEventListener('click', () => window.setTimeout(patchCartBundleImages, 80), true);
  document.addEventListener('change', () => window.setTimeout(patchCartBundleImages, 40), true);
  document.addEventListener('input', () => window.setTimeout(patchCartBundleImages, 40), true);

  const observer = new MutationObserver(() => {
    window.requestAnimationFrame(run);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();

/* V202 — interaction légère des 3 zones produit, isolée de toute logique panier. */
(() => {
  const roots = document.querySelectorAll('[data-support-zones]');
  if (!roots.length) return;
  roots.forEach((root) => {
    const triggers = [...root.querySelectorAll('[data-zone-trigger]')];
    const cards = [...root.querySelectorAll('[data-zone-card]')];
    if (!triggers.length || !cards.length) return;
    let active = 1;
    let timer = null;
    const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const setActive = (value, focusCard = false) => {
      const next = Number(value) || 1;
      active = next;
      triggers.forEach((button) => {
        const on = Number(button.dataset.zoneTrigger) === next;
        button.classList.toggle('is-active', on);
        button.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      cards.forEach((card) => {
        const on = Number(card.dataset.zoneCard) === next;
        card.classList.toggle('is-active', on);
        if (on && focusCard) card.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest' });
      });
    };

    const stop = () => { if (timer) window.clearInterval(timer); timer = null; };
    const start = () => {
      if (reduceMotion) return;
      stop();
      timer = window.setInterval(() => setActive(active >= 3 ? 1 : active + 1), 4200);
    };

    triggers.forEach((button) => {
      button.addEventListener('click', () => { setActive(button.dataset.zoneTrigger, true); start(); });
      button.addEventListener('mouseenter', () => setActive(button.dataset.zoneTrigger));
    });
    cards.forEach((card) => {
      card.addEventListener('click', () => { setActive(card.dataset.zoneCard); start(); });
      card.addEventListener('mouseenter', () => setActive(card.dataset.zoneCard));
    });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', () => window.setTimeout(() => { if (!root.contains(document.activeElement)) start(); }, 0));
    setActive(1);
    start();
  });
})();

/* V1 FINAL — PIOUPIOU LAB : onglets techniques, vues produit et zones interactives. */
(function(){
  function initTechLab(scope){
    var roots=(scope||document).querySelectorAll ? (scope||document).querySelectorAll('[data-tech-lab]') : [];
    roots.forEach(function(root){
      if(root.dataset.techLabReady==='true') return;
      root.dataset.techLabReady='true';

      var tabs=[].slice.call(root.querySelectorAll('[data-tech-tab]'));
      var panels=[].slice.call(root.querySelectorAll('[data-tech-panel]'));
      var reduceMotion=window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function activateTab(name, focusTab){
        tabs.forEach(function(tab){
          var on=tab.getAttribute('data-tech-tab')===name;
          tab.classList.toggle('is-active',on);
          tab.setAttribute('aria-selected',on?'true':'false');
          tab.tabIndex=on?0:-1;
          if(on && focusTab) tab.focus({preventScroll:true});
        });
        panels.forEach(function(panel){
          var on=panel.getAttribute('data-tech-panel')===name;
          panel.hidden=!on;
          panel.classList.toggle('is-active',on);
        });
      }

      tabs.forEach(function(tab,index){
        tab.addEventListener('click',function(){ activateTab(tab.getAttribute('data-tech-tab'),false); });
        tab.addEventListener('keydown',function(event){
          if(event.key!=='ArrowRight' && event.key!=='ArrowLeft' && event.key!=='Home' && event.key!=='End') return;
          event.preventDefault();
          var next=index;
          if(event.key==='ArrowRight') next=(index+1)%tabs.length;
          if(event.key==='ArrowLeft') next=(index-1+tabs.length)%tabs.length;
          if(event.key==='Home') next=0;
          if(event.key==='End') next=tabs.length-1;
          activateTab(tabs[next].getAttribute('data-tech-tab'),true);
        });
      });

      var formPanel=root.querySelector('[data-tech-panel="forme"]');
      if(formPanel){
        var image=formPanel.querySelector('[data-tech-view-image]');
        var hotspots=formPanel.querySelector('[data-tech-hotspots]');
        var viewNote=formPanel.querySelector('[data-tech-view-note]');
        var layout=formPanel.querySelector('.tech-lab__form-layout');
        var viewButtons=[].slice.call(formPanel.querySelectorAll('[data-tech-view]'));
        var zoneButtons=[].slice.call(formPanel.querySelectorAll('[data-tech-zone]'));
        var zoneCopies=[].slice.call(formPanel.querySelectorAll('[data-tech-zone-copy]'));
        var zoneResult=formPanel.querySelector('[data-tech-zone-result]');
        var zoneResultNumber=formPanel.querySelector('[data-tech-zone-result-number]');
        var zoneResultTitle=formPanel.querySelector('[data-tech-zone-result-title]');
        var zoneResultText=formPanel.querySelector('[data-tech-zone-result-text]');
        var zoneData={
          '1':{title:'Une position plus naturelle dès le coucher.',text:'La zone tête accueille la tête sans la surélever comme un oreiller adulte.'},
          '2':{title:'La tête reste plus facilement centrée.',text:'Le creux central crée un point d’accueil plus bas au milieu de l’oreiller.'},
          '3':{title:'Moins de glissements pendant la nuit.',text:'Les soutiens latéraux accompagnent la tête lorsqu’elle se déplace.'}
        };
        var viewData={
          face:{src:image && image.dataset.faceSrc,srcset:image && image.dataset.faceSrcset,alt:'Vue technique de face de l’oreiller Pioupiou',note:'3 zones intégrées directement dans la forme de l’oreiller.'},
          profile:{src:image && image.dataset.profileSrc,srcset:image && image.dataset.profileSrcset,alt:'Vue de profil de l’oreiller Pioupiou',note:'Le profil permet de visualiser la hauteur volontairement basse de l’oreiller.'},
          back:{src:image && image.dataset.backSrc,srcset:image && image.dataset.backSrcset,alt:'Vue du dos de l’oreiller Pioupiou',note:'Au dos, la housse conserve une surface continue, douce et déhoussable.'}
        };

        function activateZone(value){
          zoneButtons.forEach(function(button){
            button.classList.toggle('is-active',button.getAttribute('data-tech-zone')===value);
          });
          zoneCopies.forEach(function(copy){
            var on=copy.getAttribute('data-tech-zone-copy')===value;
            copy.classList.toggle('is-active',on);
            copy.classList.toggle('is-muted',!on);
            copy.setAttribute('aria-pressed',on?'true':'false');
          });
          var result=zoneData[value] || zoneData['1'];
          if(zoneResult){
            zoneResult.classList.remove('is-changing');
            void zoneResult.offsetWidth;
            zoneResult.classList.add('is-changing');
          }
          if(zoneResultNumber) zoneResultNumber.textContent=value;
          if(zoneResultTitle) zoneResultTitle.textContent=result.title;
          if(zoneResultText) zoneResultText.textContent=result.text;
        }

        zoneButtons.forEach(function(button){
          button.addEventListener('click',function(){ activateZone(button.getAttribute('data-tech-zone')); });
        });
        zoneCopies.forEach(function(copy){
          copy.addEventListener('click',function(){ activateZone(copy.getAttribute('data-tech-zone-copy')); });
          copy.addEventListener('keydown',function(event){
            if(event.key!=='Enter' && event.key!==' ') return;
            event.preventDefault();
            activateZone(copy.getAttribute('data-tech-zone-copy'));
          });
        });

        var viewSwapTimer;
        function activateView(name){
          window.clearTimeout(viewSwapTimer);
          var item=viewData[name] || viewData.face;
          viewButtons.forEach(function(button){
            var on=button.getAttribute('data-tech-view')===name;
            button.classList.toggle('is-active',on);
            button.setAttribute('aria-pressed',on?'true':'false');
          });
          if(layout) layout.classList.toggle('is-alt-view',name!=='face');
          if(hotspots) hotspots.setAttribute('aria-hidden',name==='face'?'false':'true');
          zoneButtons.forEach(function(button){ button.tabIndex=name==='face'?0:-1; });
          zoneCopies.forEach(function(copy){ copy.tabIndex=name==='face'?0:-1; copy.setAttribute('aria-hidden',name==='face'?'false':'true'); });
          if(viewNote) viewNote.textContent=item.note;
          if(!image || !item.src) return;
          image.classList.remove('is-changing');
          image.classList.add('is-changing');
          var swap=function(){
            if(item.srcset) image.setAttribute('srcset',item.srcset);
            else image.removeAttribute('srcset');
            image.setAttribute('src',item.src);
            image.setAttribute('alt',item.alt);
            window.requestAnimationFrame(function(){ image.classList.remove('is-changing'); });
          };
          if(reduceMotion) swap(); else viewSwapTimer=window.setTimeout(swap,110);
        }

        viewButtons.forEach(function(button){
          button.addEventListener('click',function(){ activateView(button.getAttribute('data-tech-view')); });
        });

        activateZone('1');
        activateView('face');
      }

      activateTab('forme',false);
    });
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){ initTechLab(document); });
  else initTechLab(document);
  document.addEventListener('shopify:section:load',function(event){ initTechLab(event.target || document); });
})();

/* V5 consolidated corrections */

/* V10.9 — une seule preuve active : la section reçoit .has-active pour verrouiller le mode nuit. */

/* V10.9 — preuve active unique + verrouillage du hover concurrent. */
